const product = [
  {
    "id": 1,
    "name": "Automobiles Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.86",
    "description": "This is a description for Automobiles Product 1.",
    "rentPerDay": "0.21",
    "rentPerMonth": "246.26",
    "rentPerYear": "2785.57",
    "securityDeposit": "312.66",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Car"
  },
  {
    "id": 2,
    "name": "Automobiles Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "90.12",
    "description": "This is a description for Automobiles Product 2.",
    "rentPerDay": "7.37",
    "rentPerMonth": "181.20",
    "rentPerYear": "894.61",
    "securityDeposit": "44.81",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Car"
  },

  {
    "id": 3,
    "name": "Automobiles Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "79.83",
    "description": "This is a description for Automobiles Product 3.",
    "rentPerDay": "0.14",
    "rentPerMonth": "268.09",
    "rentPerYear": "1450.24",
    "securityDeposit": "173.04",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Car"
  },
  {
    "id": 4,
    "name": "Automobiles Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "15.10",
    "description": "This is a description for Automobiles Product 4.",
    "rentPerDay": "5.95",
    "rentPerMonth": "226.02",
    "rentPerYear": "62.65",
    "securityDeposit": "130.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Bike"
  },
  {
    "id": 5,
    "name": "Automobiles Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.13",
    "description": "This is a description for Automobiles Product 5.",
    "rentPerDay": "5.33",
    "rentPerMonth": "136.18",
    "rentPerYear": "415.72",
    "securityDeposit": "144.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Bike"
  },
  {
    "id": 6,
    "name": "Automobiles Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.95",
    "description": "This is a description for Automobiles Product 6.",
    "rentPerDay": "0.43",
    "rentPerMonth": "49.43",
    "rentPerYear": "2163.22",
    "securityDeposit": "65.93",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Golf Cart"
  },
  {
    "id": 7,
    "name": "Automobiles Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.20",
    "description": "This is a description for Automobiles Product 7.",
    "rentPerDay": "8.52",
    "rentPerMonth": "145.58",
    "rentPerYear": "1287.81",
    "securityDeposit": "295.08",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Golf Cart"
  },
  {
    "id": 8,
    "name": "Automobiles Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "0.95",
    "description": "This is a description for Automobiles Product 8.",
    "rentPerDay": "9.34",
    "rentPerMonth": "168.98",
    "rentPerYear": "3294.60",
    "securityDeposit": "218.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Golf Cart"

  },
  {
    "id": 9,
    "name": "Automobiles Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.85",
    "description": "This is a description for Automobiles Product 9.",
    "rentPerDay": "4.89",
    "rentPerMonth": "207.66",
    "rentPerYear": "3362.13",
    "securityDeposit": "31.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Truck"

  },
  {
    "id": 10,
    "name": "Automobiles Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "44.79",
    "description": "This is a description for Automobiles Product 10.",
    "rentPerDay": "8.31",
    "rentPerMonth": "197.50",
    "rentPerYear": "364.39",
    "securityDeposit": "237.50",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Truck"
  },
  {
    "id": 11,
    "name": "Automobiles Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "35.16",
    "description": "This is a description for Automobiles Product 11.",
    "rentPerDay": "6.23",
    "rentPerMonth": "227.68",
    "rentPerYear": "1903.97",
    "securityDeposit": "191.88",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Truck"
  },
  {
    "id": 12,
    "name": "Automobiles Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.89",
    "description": "This is a description for Automobiles Product 12.",
    "rentPerDay": "6.65",
    "rentPerMonth": "80.13",
    "rentPerYear": "1618.76",
    "securityDeposit": "241.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Truck"
  },
  {
    "id": 13,
    "name": "Automobiles Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.93",
    "description": "This is a description for Automobiles Product 13.",
    "rentPerDay": "6.78",
    "rentPerMonth": "82.20",
    "rentPerYear": "1436.75",
    "securityDeposit": "465.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Truck"
  },
  {
    "id": 14,
    "name": "Automobiles Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.98",
    "description": "This is a description for Automobiles Product 14.",
    "rentPerDay": "5.03",
    "rentPerMonth": "221.27",
    "rentPerYear": "420.02",
    "securityDeposit": "472.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Others"
  },
  {
    "id": 15,
    "name": "Automobiles Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "64.97",
    "description": "This is a description for Automobiles Product 15.",
    "rentPerDay": "8.32",
    "rentPerMonth": "37.94",
    "rentPerYear": "2753.80",
    "securityDeposit": "275.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles",
    "subCategories": "Others"
  },
  {
    "id": 16,
    "name": "Automobiles Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "30.69",
    "description": "This is a description for Automobiles Product 16.",
    "rentPerDay": "8.24",
    "rentPerMonth": "75.69",
    "rentPerYear": "3256.17",
    "securityDeposit": "92.28",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles"
  },
  {
    "id": 17,
    "name": "Automobiles Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.80",
    "description": "This is a description for Automobiles Product 17.",
    "rentPerDay": "0.60",
    "rentPerMonth": "289.22",
    "rentPerYear": "75.84",
    "securityDeposit": "312.48",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles"
  },
  {
    "id": 18,
    "name": "Automobiles Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "37.01",
    "description": "This is a description for Automobiles Product 18.",
    "rentPerDay": "1.82",
    "rentPerMonth": "30.96",
    "rentPerYear": "1215.46",
    "securityDeposit": "216.45",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles"
  },
  {
    "id": 19,
    "name": "Automobiles Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "13.91",
    "description": "This is a description for Automobiles Product 19.",
    "rentPerDay": "7.56",
    "rentPerMonth": "125.37",
    "rentPerYear": "2503.04",
    "securityDeposit": "86.31",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles"
  },
  {
    "id": 20,
    "name": "Automobiles Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.73",
    "description": "This is a description for Automobiles Product 20.",
    "rentPerDay": "8.78",
    "rentPerMonth": "129.32",
    "rentPerYear": "1271.67",
    "securityDeposit": "488.38",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Automobiles"
  },
  {
    "id": 21,
    "name": "Biking & Hiking Gears Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "63.86",
    "description": "This is a description for Biking & Hiking Gears Product 1.",
    "rentPerDay": "6.97",
    "rentPerMonth": "151.48",
    "rentPerYear": "2081.40",
    "securityDeposit": "480.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 22,
    "name": "Biking & Hiking Gears Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.23",
    "description": "This is a description for Biking & Hiking Gears Product 2.",
    "rentPerDay": "1.81",
    "rentPerMonth": "298.05",
    "rentPerYear": "1644.29",
    "securityDeposit": "168.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 23,
    "name": "Biking & Hiking Gears Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "97.90",
    "description": "This is a description for Biking & Hiking Gears Product 3.",
    "rentPerDay": "8.61",
    "rentPerMonth": "144.80",
    "rentPerYear": "2510.47",
    "securityDeposit": "390.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 24,
    "name": "Biking & Hiking Gears Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "55.12",
    "description": "This is a description for Biking & Hiking Gears Product 4.",
    "rentPerDay": "5.96",
    "rentPerMonth": "24.80",
    "rentPerYear": "407.03",
    "securityDeposit": "6.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 25,
    "name": "Biking & Hiking Gears Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.84",
    "description": "This is a description for Biking & Hiking Gears Product 5.",
    "rentPerDay": "7.22",
    "rentPerMonth": "258.39",
    "rentPerYear": "2357.52",
    "securityDeposit": "450.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 26,
    "name": "Biking & Hiking Gears Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "0.33",
    "description": "This is a description for Biking & Hiking Gears Product 6.",
    "rentPerDay": "8.90",
    "rentPerMonth": "113.26",
    "rentPerYear": "2048.78",
    "securityDeposit": "135.82",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 27,
    "name": "Biking & Hiking Gears Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.95",
    "description": "This is a description for Biking & Hiking Gears Product 7.",
    "rentPerDay": "5.39",
    "rentPerMonth": "255.69",
    "rentPerYear": "1858.68",
    "securityDeposit": "338.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 28,
    "name": "Biking & Hiking Gears Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.64",
    "description": "This is a description for Biking & Hiking Gears Product 8.",
    "rentPerDay": "4.25",
    "rentPerMonth": "87.77",
    "rentPerYear": "3073.59",
    "securityDeposit": "272.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 29,
    "name": "Biking & Hiking Gears Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "50.03",
    "description": "This is a description for Biking & Hiking Gears Product 9.",
    "rentPerDay": "9.22",
    "rentPerMonth": "226.78",
    "rentPerYear": "3491.44",
    "securityDeposit": "244.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 30,
    "name": "Biking & Hiking Gears Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.34",
    "description": "This is a description for Biking & Hiking Gears Product 10.",
    "rentPerDay": "2.20",
    "rentPerMonth": "167.35",
    "rentPerYear": "1030.22",
    "securityDeposit": "135.33",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 31,
    "name": "Biking & Hiking Gears Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.27",
    "description": "This is a description for Biking & Hiking Gears Product 11.",
    "rentPerDay": "7.27",
    "rentPerMonth": "91.19",
    "rentPerYear": "1268.95",
    "securityDeposit": "3.90",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 32,
    "name": "Biking & Hiking Gears Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "44.66",
    "description": "This is a description for Biking & Hiking Gears Product 12.",
    "rentPerDay": "3.60",
    "rentPerMonth": "200.44",
    "rentPerYear": "1713.01",
    "securityDeposit": "490.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 33,
    "name": "Biking & Hiking Gears Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.81",
    "description": "This is a description for Biking & Hiking Gears Product 13.",
    "rentPerDay": "9.92",
    "rentPerMonth": "131.18",
    "rentPerYear": "2971.91",
    "securityDeposit": "352.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 34,
    "name": "Biking & Hiking Gears Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.24",
    "description": "This is a description for Biking & Hiking Gears Product 14.",
    "rentPerDay": "1.23",
    "rentPerMonth": "20.99",
    "rentPerYear": "1739.30",
    "securityDeposit": "368.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 35,
    "name": "Biking & Hiking Gears Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "41.10",
    "description": "This is a description for Biking & Hiking Gears Product 15.",
    "rentPerDay": "5.30",
    "rentPerMonth": "268.90",
    "rentPerYear": "2139.56",
    "securityDeposit": "206.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 36,
    "name": "Biking & Hiking Gears Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.18",
    "description": "This is a description for Biking & Hiking Gears Product 16.",
    "rentPerDay": "5.59",
    "rentPerMonth": "114.46",
    "rentPerYear": "3136.66",
    "securityDeposit": "401.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 37,
    "name": "Biking & Hiking Gears Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.07",
    "description": "This is a description for Biking & Hiking Gears Product 17.",
    "rentPerDay": "8.97",
    "rentPerMonth": "230.29",
    "rentPerYear": "3327.21",
    "securityDeposit": "398.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 38,
    "name": "Biking & Hiking Gears Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.50",
    "description": "This is a description for Biking & Hiking Gears Product 18.",
    "rentPerDay": "9.77",
    "rentPerMonth": "230.29",
    "rentPerYear": "1829.48",
    "securityDeposit": "233.82",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 39,
    "name": "Biking & Hiking Gears Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "83.54",
    "description": "This is a description for Biking & Hiking Gears Product 19.",
    "rentPerDay": "8.31",
    "rentPerMonth": "285.97",
    "rentPerYear": "1740.32",
    "securityDeposit": "143.64",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 40,
    "name": "Biking & Hiking Gears Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "90.30",
    "description": "This is a description for Biking & Hiking Gears Product 20.",
    "rentPerDay": "4.28",
    "rentPerMonth": "19.73",
    "rentPerYear": "419.05",
    "securityDeposit": "488.44",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Biking & Hiking Gears"
  },
  {
    "id": 521,
    "name": "Saree",
    "image": "https://m.media-amazon.com/images/I/91va0UaysuL._SY550_.jpg",
    "price": "150",
    "description": "A traditional garment worn by women, it is an unstitched drape that ranges from 5 to 9 meters.",
    "rentPerDay": "150",
    "rentPerMonth": "1399",
    "rentPerYear": "4999",
    "securityDeposit": "399",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 522,
    "name": "Kurta",
    "image": "https://m.media-amazon.com/images/I/61r6qy9Og0L._SY741_.jpg",
    "price": "99",
    "description": "Traditional menswear of India, it comes in various forms and styles.",
    "rentPerDay": "99",
    "rentPerMonth": "522",
    "rentPerYear": "1700",
    "securityDeposit": "399",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 523,
    "name": "Sherwani",
    "image": "https://m.media-amazon.com/images/I/51DaM3noJnL._SX679_.jpg",
    "price": "748",
    "description": "A traditional Indian",
    "rentPerDay": "748",
    "rentPerMonth": "3999",
    "rentPerYear": "9999",
    "securityDeposit": "999",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"
  },
  {
    "id": 524,
    "name": "Lehenga",
    "image": "https://m.media-amazon.com/images/I/91qt3tdMt9L._SX425_.jpg",
    "price": "1299",
    "description": "A traditional Indian",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"
  },
  {
    "id": 525,
    "name": "Dhoti",
    "image": "https://m.media-amazon.com/images/I/714f8DQSOWL._SX522_.jpg",
    "price": "399",
    "description": "A traditional men’s garment, worn as bottom wear in Indian subcontinent",
    "rentPerDay": "99",
    "rentPerMonth": "300",
    "rentPerYear": "500",
    "securityDeposit": "100",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"
  },
  {
    "id": 526,
    "name": "Ghagra Choli",
    "image": "https://m.media-amazon.com/images/I/51uSFpmsubL._SY550_.jpg",
    "price": "1000",
    "description": "Also known as Lehenga Choli, it’s a traditional wear in North India",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 527,
    "name": "Salwar Kameez",
    "image": "https://m.media-amazon.com/images/I/91n5s+BPQSL._SY550_.jpg",
    "price": "499",
    "description": "A traditional outfit originating in the Indian subcontinent, it is generic term used to describe different styles of dress",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 528,
    "name": "Pathani Suit",
    "image": "https://m.media-amazon.com/images/I/61uEa6ecMbL._SY606_.jpg",
    "price": "400",
    "description": "A style of dress worn commonly in North India and Pakistan",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 529,
    "name": "Mekhela Chador",
    "image": "https://m.media-amazon.com/images/I/81lehdCv8zL._SX466_.jpg",
    "price": "699",
    "description": "Traditional Assames attire worn by women",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 530,
    "name": "Bandhgala",
    "image": "https://m.media-amazon.com/images/I/81n3Y+EOFUL._SX522_.jpg",
    "price": "799",
    "description": "Also known as Jodhpuri suit, it is a formal evening suit from India",
    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"

  },
  {
    "id": 531,
    "name": "Sharara",
    "image": "https://m.media-amazon.com/images/I/71joBKNI5WL._SY550_.jpg",
    "price": "799",
    "description": "A pair of loose pleated trousers worn by women from the Indian subcontinent",

    "rentPerDay": "99",
    "rentPerMonth": "1299",
    "rentPerYear": "9999",
    "securityDeposit": "700",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Costumes"
  },
  {
    "id": 41,
    "name": "Books Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "32.16",
    "description": "This is a description for Books Product 1.",
    "rentPerDay": "0.69",
    "rentPerMonth": "17.38",
    "rentPerYear": "2351.23",
    "securityDeposit": "226.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 42,
    "name": "Books Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "95.82",
    "description": "This is a description for Books Product 2.",
    "rentPerDay": "8.23",
    "rentPerMonth": "278.77",
    "rentPerYear": "1606.62",
    "securityDeposit": "79.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 43,
    "name": "Books Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "92.13",
    "description": "This is a description for Books Product 3.",
    "rentPerDay": "7.52",
    "rentPerMonth": "163.41",
    "rentPerYear": "2461.29",
    "securityDeposit": "216.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 44,
    "name": "Books Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.68",
    "description": "This is a description for Books Product 4.",
    "rentPerDay": "6.86",
    "rentPerMonth": "197.34",
    "rentPerYear": "638.01",
    "securityDeposit": "253.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 45,
    "name": "Books Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "12.18",
    "description": "This is a description for Books Product 5.",
    "rentPerDay": "7.45",
    "rentPerMonth": "34.02",
    "rentPerYear": "321.71",
    "securityDeposit": "42.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 46,
    "name": "Books Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.07",
    "description": "This is a description for Books Product 6.",
    "rentPerDay": "3.82",
    "rentPerMonth": "127.64",
    "rentPerYear": "1819.17",
    "securityDeposit": "212.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 47,
    "name": "Books Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.75",
    "description": "This is a description for Books Product 7.",
    "rentPerDay": "8.71",
    "rentPerMonth": "269.80",
    "rentPerYear": "275.77",
    "securityDeposit": "44.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 48,
    "name": "Books Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.90",
    "description": "This is a description for Books Product 8.",
    "rentPerDay": "2.05",
    "rentPerMonth": "57.82",
    "rentPerYear": "1140.94",
    "securityDeposit": "324.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 49,
    "name": "Books Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.93",
    "description": "This is a description for Books Product 9.",
    "rentPerDay": "3.61",
    "rentPerMonth": "151.92",
    "rentPerYear": "1103.18",
    "securityDeposit": "426.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 50,
    "name": "Books Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.92",
    "description": "This is a description for Books Product 10.",
    "rentPerDay": "7.67",
    "rentPerMonth": "117.18",
    "rentPerYear": "2537.09",
    "securityDeposit": "398.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 51,
    "name": "Books Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "40.49",
    "description": "This is a description for Books Product 11.",
    "rentPerDay": "1.00",
    "rentPerMonth": "138.29",
    "rentPerYear": "2960.96",
    "securityDeposit": "136.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 52,
    "name": "Books Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.87",
    "description": "This is a description for Books Product 12.",
    "rentPerDay": "5.80",
    "rentPerMonth": "171.35",
    "rentPerYear": "2024.20",
    "securityDeposit": "209.47",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 53,
    "name": "Books Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.31",
    "description": "This is a description for Books Product 13.",
    "rentPerDay": "7.79",
    "rentPerMonth": "233.89",
    "rentPerYear": "1741.69",
    "securityDeposit": "431.98",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 54,
    "name": "Books Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.43",
    "description": "This is a description for Books Product 14.",
    "rentPerDay": "1.54",
    "rentPerMonth": "196.27",
    "rentPerYear": "3411.57",
    "securityDeposit": "51.06",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 55,
    "name": "Books Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "71.92",
    "description": "This is a description for Books Product 15.",
    "rentPerDay": "5.01",
    "rentPerMonth": "276.84",
    "rentPerYear": "1725.98",
    "securityDeposit": "486.30",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 56,
    "name": "Books Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.72",
    "description": "This is a description for Books Product 16.",
    "rentPerDay": "4.74",
    "rentPerMonth": "107.80",
    "rentPerYear": "1773.78",
    "securityDeposit": "145.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 57,
    "name": "Books Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "95.71",
    "description": "This is a description for Books Product 17.",
    "rentPerDay": "3.42",
    "rentPerMonth": "189.90",
    "rentPerYear": "766.50",
    "securityDeposit": "319.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 58,
    "name": "Books Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "26.15",
    "description": "This is a description for Books Product 18.",
    "rentPerDay": "8.40",
    "rentPerMonth": "141.81",
    "rentPerYear": "1042.01",
    "securityDeposit": "452.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 59,
    "name": "Books Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.61",
    "description": "This is a description for Books Product 19.",
    "rentPerDay": "1.28",
    "rentPerMonth": "128.55",
    "rentPerYear": "1914.51",
    "securityDeposit": "432.87",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 60,
    "name": "Books Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.56",
    "description": "This is a description for Books Product 20.",
    "rentPerDay": "5.74",
    "rentPerMonth": "262.39",
    "rentPerYear": "501.35",
    "securityDeposit": "385.28",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Books"
  },
  {
    "id": 61,
    "name": "Camera & Lenseses Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "72.10",
    "description": "This is a description for Camera & Lenseses Product 1.",
    "rentPerDay": "9.63",
    "rentPerMonth": "230.66",
    "rentPerYear": "2832.84",
    "securityDeposit": "290.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 62,
    "name": "Camera & Lenseses Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.51",
    "description": "This is a description for Camera & Lenseses Product 2.",
    "rentPerDay": "4.42",
    "rentPerMonth": "145.83",
    "rentPerYear": "3291.94",
    "securityDeposit": "257.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 63,
    "name": "Camera & Lenseses Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.83",
    "description": "This is a description for Camera & Lenseses Product 3.",
    "rentPerDay": "9.20",
    "rentPerMonth": "281.51",
    "rentPerYear": "2432.33",
    "securityDeposit": "300.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 64,
    "name": "Camera & Lenseses Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.37",
    "description": "This is a description for Camera & Lenseses Product 4.",
    "rentPerDay": "2.21",
    "rentPerMonth": "23.86",
    "rentPerYear": "2005.41",
    "securityDeposit": "94.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 65,
    "name": "Camera & Lenseses Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.43",
    "description": "This is a description for Camera & Lenseses Product 5.",
    "rentPerDay": "4.46",
    "rentPerMonth": "263.56",
    "rentPerYear": "1420.12",
    "securityDeposit": "388.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 66,
    "name": "Camera & Lenseses Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "76.12",
    "description": "This is a description for Camera & Lenseses Product 6.",
    "rentPerDay": "4.13",
    "rentPerMonth": "198.16",
    "rentPerYear": "2077.82",
    "securityDeposit": "320.26",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 67,
    "name": "Camera & Lenseses Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.04",
    "description": "This is a description for Camera & Lenseses Product 7.",
    "rentPerDay": "9.73",
    "rentPerMonth": "250.22",
    "rentPerYear": "1269.50",
    "securityDeposit": "331.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 68,
    "name": "Camera & Lenseses Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "25.80",
    "description": "This is a description for Camera & Lenseses Product 8.",
    "rentPerDay": "8.42",
    "rentPerMonth": "276.53",
    "rentPerYear": "1692.18",
    "securityDeposit": "234.04",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 69,
    "name": "Camera & Lenseses Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.26",
    "description": "This is a description for Camera & Lenseses Product 9.",
    "rentPerDay": "0.13",
    "rentPerMonth": "55.73",
    "rentPerYear": "1897.85",
    "securityDeposit": "378.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 70,
    "name": "Camera & Lenseses Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "90.21",
    "description": "This is a description for Camera & Lenseses Product 10.",
    "rentPerDay": "4.94",
    "rentPerMonth": "2.10",
    "rentPerYear": "1646.58",
    "securityDeposit": "401.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 71,
    "name": "Camera & Lenseses Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.42",
    "description": "This is a description for Camera & Lenseses Product 11.",
    "rentPerDay": "9.26",
    "rentPerMonth": "31.58",
    "rentPerYear": "1271.56",
    "securityDeposit": "87.45",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 72,
    "name": "Camera & Lenseses Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.07",
    "description": "This is a description for Camera & Lenseses Product 12.",
    "rentPerDay": "8.42",
    "rentPerMonth": "116.92",
    "rentPerYear": "1125.91",
    "securityDeposit": "437.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 73,
    "name": "Camera & Lenseses Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "30.67",
    "description": "This is a description for Camera & Lenseses Product 13.",
    "rentPerDay": "6.54",
    "rentPerMonth": "212.94",
    "rentPerYear": "3268.60",
    "securityDeposit": "165.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 74,
    "name": "Camera & Lenseses Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.72",
    "description": "This is a description for Camera & Lenseses Product 14.",
    "rentPerDay": "5.22",
    "rentPerMonth": "244.37",
    "rentPerYear": "2908.54",
    "securityDeposit": "288.29",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 75,
    "name": "Camera & Lenseses Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.88",
    "description": "This is a description for Camera & Lenseses Product 15.",
    "rentPerDay": "5.62",
    "rentPerMonth": "145.20",
    "rentPerYear": "2328.74",
    "securityDeposit": "212.66",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 76,
    "name": "Camera & Lenseses Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.52",
    "description": "This is a description for Camera & Lenseses Product 16.",
    "rentPerDay": "2.94",
    "rentPerMonth": "97.15",
    "rentPerYear": "1308.83",
    "securityDeposit": "138.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 77,
    "name": "Camera & Lenseses Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "72.36",
    "description": "This is a description for Camera & Lenseses Product 17.",
    "rentPerDay": "1.78",
    "rentPerMonth": "273.52",
    "rentPerYear": "900.19",
    "securityDeposit": "368.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 78,
    "name": "Camera & Lenseses Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "96.81",
    "description": "This is a description for Camera & Lenseses Product 18.",
    "rentPerDay": "6.17",
    "rentPerMonth": "218.32",
    "rentPerYear": "3046.03",
    "securityDeposit": "489.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 79,
    "name": "Camera & Lenseses Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "63.08",
    "description": "This is a description for Camera & Lenseses Product 19.",
    "rentPerDay": "5.14",
    "rentPerMonth": "131.47",
    "rentPerYear": "2134.55",
    "securityDeposit": "90.81",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 80,
    "name": "Camera & Lenseses Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.65",
    "description": "This is a description for Camera & Lenseses Product 20.",
    "rentPerDay": "7.45",
    "rentPerMonth": "197.69",
    "rentPerYear": "2286.95",
    "securityDeposit": "37.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Camera & Lenseses"
  },
  {
    "id": 81,
    "name": "Construction Machines & Manpower Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.66",
    "description": "This is a description for Construction Machines & Manpower Product 1.",
    "rentPerDay": "1.26",
    "rentPerMonth": "76.52",
    "rentPerYear": "451.62",
    "securityDeposit": "396.72",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 82,
    "name": "Construction Machines & Manpower Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.18",
    "description": "This is a description for Construction Machines & Manpower Product 2.",
    "rentPerDay": "6.55",
    "rentPerMonth": "40.16",
    "rentPerYear": "747.20",
    "securityDeposit": "102.47",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 83,
    "name": "Construction Machines & Manpower Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.19",
    "description": "This is a description for Construction Machines & Manpower Product 3.",
    "rentPerDay": "4.10",
    "rentPerMonth": "298.88",
    "rentPerYear": "442.73",
    "securityDeposit": "384.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 84,
    "name": "Construction Machines & Manpower Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.80",
    "description": "This is a description for Construction Machines & Manpower Product 4.",
    "rentPerDay": "2.45",
    "rentPerMonth": "5.98",
    "rentPerYear": "200.20",
    "securityDeposit": "475.27",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 85,
    "name": "Construction Machines & Manpower Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "7.21",
    "description": "This is a description for Construction Machines & Manpower Product 5.",
    "rentPerDay": "4.97",
    "rentPerMonth": "61.62",
    "rentPerYear": "2714.59",
    "securityDeposit": "293.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 86,
    "name": "Construction Machines & Manpower Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.97",
    "description": "This is a description for Construction Machines & Manpower Product 6.",
    "rentPerDay": "5.77",
    "rentPerMonth": "49.34",
    "rentPerYear": "1272.63",
    "securityDeposit": "80.83",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 87,
    "name": "Construction Machines & Manpower Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "18.05",
    "description": "This is a description for Construction Machines & Manpower Product 7.",
    "rentPerDay": "9.32",
    "rentPerMonth": "7.65",
    "rentPerYear": "849.14",
    "securityDeposit": "5.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 88,
    "name": "Construction Machines & Manpower Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.47",
    "description": "This is a description for Construction Machines & Manpower Product 8.",
    "rentPerDay": "7.17",
    "rentPerMonth": "97.96",
    "rentPerYear": "1147.81",
    "securityDeposit": "225.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 89,
    "name": "Construction Machines & Manpower Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "18.70",
    "description": "This is a description for Construction Machines & Manpower Product 9.",
    "rentPerDay": "9.06",
    "rentPerMonth": "12.72",
    "rentPerYear": "2422.47",
    "securityDeposit": "307.25",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 90,
    "name": "Construction Machines & Manpower Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "27.92",
    "description": "This is a description for Construction Machines & Manpower Product 10.",
    "rentPerDay": "0.22",
    "rentPerMonth": "120.63",
    "rentPerYear": "1322.39",
    "securityDeposit": "86.88",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 91,
    "name": "Construction Machines & Manpower Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.33",
    "description": "This is a description for Construction Machines & Manpower Product 11.",
    "rentPerDay": "0.39",
    "rentPerMonth": "122.93",
    "rentPerYear": "178.09",
    "securityDeposit": "6.01",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 92,
    "name": "Construction Machines & Manpower Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.32",
    "description": "This is a description for Construction Machines & Manpower Product 12.",
    "rentPerDay": "8.25",
    "rentPerMonth": "7.21",
    "rentPerYear": "1760.92",
    "securityDeposit": "33.01",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 93,
    "name": "Construction Machines & Manpower Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.62",
    "description": "This is a description for Construction Machines & Manpower Product 13.",
    "rentPerDay": "2.79",
    "rentPerMonth": "175.27",
    "rentPerYear": "1761.16",
    "securityDeposit": "190.73",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 94,
    "name": "Construction Machines & Manpower Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "72.36",
    "description": "This is a description for Construction Machines & Manpower Product 14.",
    "rentPerDay": "9.14",
    "rentPerMonth": "196.43",
    "rentPerYear": "2338.87",
    "securityDeposit": "320.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 95,
    "name": "Construction Machines & Manpower Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.59",
    "description": "This is a description for Construction Machines & Manpower Product 15.",
    "rentPerDay": "0.10",
    "rentPerMonth": "255.56",
    "rentPerYear": "1641.22",
    "securityDeposit": "442.08",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 96,
    "name": "Construction Machines & Manpower Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.88",
    "description": "This is a description for Construction Machines & Manpower Product 16.",
    "rentPerDay": "5.62",
    "rentPerMonth": "281.77",
    "rentPerYear": "1802.74",
    "securityDeposit": "32.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 97,
    "name": "Construction Machines & Manpower Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "35.23",
    "description": "This is a description for Construction Machines & Manpower Product 17.",
    "rentPerDay": "5.19",
    "rentPerMonth": "219.28",
    "rentPerYear": "79.79",
    "securityDeposit": "145.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 98,
    "name": "Construction Machines & Manpower Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.74",
    "description": "This is a description for Construction Machines & Manpower Product 18.",
    "rentPerDay": "4.88",
    "rentPerMonth": "23.52",
    "rentPerYear": "438.89",
    "securityDeposit": "299.04",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 99,
    "name": "Construction Machines & Manpower Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.88",
    "description": "This is a description for Construction Machines & Manpower Product 19.",
    "rentPerDay": "5.46",
    "rentPerMonth": "1.64",
    "rentPerYear": "2288.60",
    "securityDeposit": "105.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 100,
    "name": "Construction Machines & Manpower Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "92.29",
    "description": "This is a description for Construction Machines & Manpower Product 20.",
    "rentPerDay": "5.60",
    "rentPerMonth": "65.84",
    "rentPerYear": "408.26",
    "securityDeposit": "67.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Construction Machines & Manpower"
  },
  {
    "id": 101,
    "name": "Drones Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.68",
    "description": "This is a description for Drones Product 1.",
    "rentPerDay": "4.45",
    "rentPerMonth": "14.72",
    "rentPerYear": "244.06",
    "securityDeposit": "119.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 102,
    "name": "Drones Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.53",
    "description": "This is a description for Drones Product 2.",
    "rentPerDay": "6.86",
    "rentPerMonth": "262.65",
    "rentPerYear": "827.43",
    "securityDeposit": "284.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 103,
    "name": "Drones Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.70",
    "description": "This is a description for Drones Product 3.",
    "rentPerDay": "2.80",
    "rentPerMonth": "265.68",
    "rentPerYear": "605.61",
    "securityDeposit": "56.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 104,
    "name": "Drones Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.93",
    "description": "This is a description for Drones Product 4.",
    "rentPerDay": "9.17",
    "rentPerMonth": "277.57",
    "rentPerYear": "114.56",
    "securityDeposit": "220.65",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 105,
    "name": "Drones Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.47",
    "description": "This is a description for Drones Product 5.",
    "rentPerDay": "2.34",
    "rentPerMonth": "68.50",
    "rentPerYear": "3247.84",
    "securityDeposit": "415.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 106,
    "name": "Drones Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.99",
    "description": "This is a description for Drones Product 6.",
    "rentPerDay": "2.12",
    "rentPerMonth": "201.39",
    "rentPerYear": "1049.44",
    "securityDeposit": "89.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 107,
    "name": "Drones Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "10.99",
    "description": "This is a description for Drones Product 7.",
    "rentPerDay": "2.21",
    "rentPerMonth": "182.90",
    "rentPerYear": "1783.64",
    "securityDeposit": "76.50",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 108,
    "name": "Drones Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.91",
    "description": "This is a description for Drones Product 8.",
    "rentPerDay": "5.05",
    "rentPerMonth": "205.60",
    "rentPerYear": "2575.15",
    "securityDeposit": "194.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 109,
    "name": "Drones Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "35.85",
    "description": "This is a description for Drones Product 9.",
    "rentPerDay": "6.46",
    "rentPerMonth": "172.04",
    "rentPerYear": "59.72",
    "securityDeposit": "485.17",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 110,
    "name": "Drones Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "63.51",
    "description": "This is a description for Drones Product 10.",
    "rentPerDay": "3.71",
    "rentPerMonth": "206.32",
    "rentPerYear": "3386.61",
    "securityDeposit": "40.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 111,
    "name": "Drones Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "53.17",
    "description": "This is a description for Drones Product 11.",
    "rentPerDay": "0.95",
    "rentPerMonth": "280.18",
    "rentPerYear": "1781.98",
    "securityDeposit": "485.26",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 112,
    "name": "Drones Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "10.47",
    "description": "This is a description for Drones Product 12.",
    "rentPerDay": "3.62",
    "rentPerMonth": "224.40",
    "rentPerYear": "1267.15",
    "securityDeposit": "193.49",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 113,
    "name": "Drones Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.96",
    "description": "This is a description for Drones Product 13.",
    "rentPerDay": "1.32",
    "rentPerMonth": "199.83",
    "rentPerYear": "546.23",
    "securityDeposit": "95.61",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 114,
    "name": "Drones Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.37",
    "description": "This is a description for Drones Product 14.",
    "rentPerDay": "1.31",
    "rentPerMonth": "8.83",
    "rentPerYear": "3419.93",
    "securityDeposit": "202.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 115,
    "name": "Drones Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.82",
    "description": "This is a description for Drones Product 15.",
    "rentPerDay": "1.75",
    "rentPerMonth": "269.67",
    "rentPerYear": "693.71",
    "securityDeposit": "317.67",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 116,
    "name": "Drones Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.00",
    "description": "This is a description for Drones Product 16.",
    "rentPerDay": "8.94",
    "rentPerMonth": "43.65",
    "rentPerYear": "1950.45",
    "securityDeposit": "295.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 117,
    "name": "Drones Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.86",
    "description": "This is a description for Drones Product 17.",
    "rentPerDay": "3.46",
    "rentPerMonth": "265.06",
    "rentPerYear": "3179.36",
    "securityDeposit": "166.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 118,
    "name": "Drones Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.82",
    "description": "This is a description for Drones Product 18.",
    "rentPerDay": "0.13",
    "rentPerMonth": "162.50",
    "rentPerYear": "2243.19",
    "securityDeposit": "348.66",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 119,
    "name": "Drones Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "97.77",
    "description": "This is a description for Drones Product 19.",
    "rentPerDay": "2.64",
    "rentPerMonth": "151.27",
    "rentPerYear": "459.73",
    "securityDeposit": "328.48",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 120,
    "name": "Drones Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.20",
    "description": "This is a description for Drones Product 20.",
    "rentPerDay": "1.41",
    "rentPerMonth": "158.89",
    "rentPerYear": "2321.52",
    "securityDeposit": "108.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Drones"
  },
  {
    "id": 121,
    "name": "Electronics Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.06",
    "description": "This is a description for Electronics Product 1.",
    "rentPerDay": "4.77",
    "rentPerMonth": "95.95",
    "rentPerYear": "374.39",
    "securityDeposit": "392.93",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 122,
    "name": "Electronics Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.91",
    "description": "This is a description for Electronics Product 2.",
    "rentPerDay": "3.95",
    "rentPerMonth": "246.16",
    "rentPerYear": "1868.75",
    "securityDeposit": "424.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 123,
    "name": "Electronics Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.83",
    "description": "This is a description for Electronics Product 3.",
    "rentPerDay": "4.05",
    "rentPerMonth": "73.37",
    "rentPerYear": "2949.60",
    "securityDeposit": "261.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 124,
    "name": "Electronics Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.68",
    "description": "This is a description for Electronics Product 4.",
    "rentPerDay": "6.29",
    "rentPerMonth": "260.67",
    "rentPerYear": "1736.45",
    "securityDeposit": "63.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 125,
    "name": "Electronics Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.13",
    "description": "This is a description for Electronics Product 5.",
    "rentPerDay": "1.85",
    "rentPerMonth": "170.87",
    "rentPerYear": "1607.55",
    "securityDeposit": "57.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 126,
    "name": "Electronics Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.21",
    "description": "This is a description for Electronics Product 6.",
    "rentPerDay": "5.65",
    "rentPerMonth": "186.32",
    "rentPerYear": "1183.08",
    "securityDeposit": "211.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 127,
    "name": "Electronics Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "96.51",
    "description": "This is a description for Electronics Product 7.",
    "rentPerDay": "8.97",
    "rentPerMonth": "126.18",
    "rentPerYear": "1714.98",
    "securityDeposit": "119.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 128,
    "name": "Electronics Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.58",
    "description": "This is a description for Electronics Product 8.",
    "rentPerDay": "7.72",
    "rentPerMonth": "0.69",
    "rentPerYear": "2321.70",
    "securityDeposit": "278.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 129,
    "name": "Electronics Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.49",
    "description": "This is a description for Electronics Product 9.",
    "rentPerDay": "7.51",
    "rentPerMonth": "45.70",
    "rentPerYear": "1328.26",
    "securityDeposit": "351.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 130,
    "name": "Electronics Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.03",
    "description": "This is a description for Electronics Product 10.",
    "rentPerDay": "5.50",
    "rentPerMonth": "87.47",
    "rentPerYear": "703.08",
    "securityDeposit": "65.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 131,
    "name": "Electronics Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "51.42",
    "description": "This is a description for Electronics Product 11.",
    "rentPerDay": "7.55",
    "rentPerMonth": "205.74",
    "rentPerYear": "917.93",
    "securityDeposit": "97.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 132,
    "name": "Electronics Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "38.29",
    "description": "This is a description for Electronics Product 12.",
    "rentPerDay": "9.36",
    "rentPerMonth": "68.95",
    "rentPerYear": "2542.51",
    "securityDeposit": "348.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 133,
    "name": "Electronics Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.68",
    "description": "This is a description for Electronics Product 13.",
    "rentPerDay": "6.60",
    "rentPerMonth": "1.60",
    "rentPerYear": "1825.01",
    "securityDeposit": "236.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 134,
    "name": "Electronics Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.36",
    "description": "This is a description for Electronics Product 14.",
    "rentPerDay": "8.21",
    "rentPerMonth": "114.63",
    "rentPerYear": "1024.02",
    "securityDeposit": "294.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 135,
    "name": "Electronics Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "50.21",
    "description": "This is a description for Electronics Product 15.",
    "rentPerDay": "3.15",
    "rentPerMonth": "99.24",
    "rentPerYear": "3488.15",
    "securityDeposit": "12.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 136,
    "name": "Electronics Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "32.63",
    "description": "This is a description for Electronics Product 16.",
    "rentPerDay": "2.65",
    "rentPerMonth": "202.14",
    "rentPerYear": "3271.17",
    "securityDeposit": "429.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 137,
    "name": "Electronics Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.32",
    "description": "This is a description for Electronics Product 17.",
    "rentPerDay": "4.70",
    "rentPerMonth": "65.85",
    "rentPerYear": "3373.57",
    "securityDeposit": "400.29",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 138,
    "name": "Electronics Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "37.77",
    "description": "This is a description for Electronics Product 18.",
    "rentPerDay": "8.81",
    "rentPerMonth": "113.20",
    "rentPerYear": "3539.88",
    "securityDeposit": "78.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 139,
    "name": "Electronics Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "16.63",
    "description": "This is a description for Electronics Product 19.",
    "rentPerDay": "2.73",
    "rentPerMonth": "36.98",
    "rentPerYear": "814.77",
    "securityDeposit": "1.16",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 140,
    "name": "Electronics Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.10",
    "description": "This is a description for Electronics Product 20.",
    "rentPerDay": "7.29",
    "rentPerMonth": "66.93",
    "rentPerYear": "1671.22",
    "securityDeposit": "352.18",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Electronics"
  },
  {
    "id": 141,
    "name": "Events Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "45.13",
    "description": "This is a description for Events Product 1.",
    "rentPerDay": "9.98",
    "rentPerMonth": "27.54",
    "rentPerYear": "192.48",
    "securityDeposit": "377.85",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 142,
    "name": "Events Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "4.23",
    "description": "This is a description for Events Product 2.",
    "rentPerDay": "5.90",
    "rentPerMonth": "241.25",
    "rentPerYear": "1226.49",
    "securityDeposit": "98.01",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 143,
    "name": "Events Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "24.29",
    "description": "This is a description for Events Product 3.",
    "rentPerDay": "0.59",
    "rentPerMonth": "151.79",
    "rentPerYear": "405.88",
    "securityDeposit": "496.29",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 144,
    "name": "Events Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "7.95",
    "description": "This is a description for Events Product 4.",
    "rentPerDay": "3.91",
    "rentPerMonth": "207.82",
    "rentPerYear": "3578.58",
    "securityDeposit": "3.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 145,
    "name": "Events Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "52.73",
    "description": "This is a description for Events Product 5.",
    "rentPerDay": "7.46",
    "rentPerMonth": "101.13",
    "rentPerYear": "1906.97",
    "securityDeposit": "348.06",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 146,
    "name": "Events Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "32.05",
    "description": "This is a description for Events Product 6.",
    "rentPerDay": "5.47",
    "rentPerMonth": "29.98",
    "rentPerYear": "1907.92",
    "securityDeposit": "36.38",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 147,
    "name": "Events Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "17.39",
    "description": "This is a description for Events Product 7.",
    "rentPerDay": "7.37",
    "rentPerMonth": "153.61",
    "rentPerYear": "2788.00",
    "securityDeposit": "14.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 148,
    "name": "Events Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "53.78",
    "description": "This is a description for Events Product 8.",
    "rentPerDay": "4.02",
    "rentPerMonth": "296.63",
    "rentPerYear": "1801.84",
    "securityDeposit": "408.02",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 149,
    "name": "Events Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.23",
    "description": "This is a description for Events Product 9.",
    "rentPerDay": "3.13",
    "rentPerMonth": "232.52",
    "rentPerYear": "1614.28",
    "securityDeposit": "469.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 150,
    "name": "Events Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.73",
    "description": "This is a description for Events Product 10.",
    "rentPerDay": "6.11",
    "rentPerMonth": "156.37",
    "rentPerYear": "496.82",
    "securityDeposit": "37.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 151,
    "name": "Events Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "12.84",
    "description": "This is a description for Events Product 11.",
    "rentPerDay": "7.60",
    "rentPerMonth": "125.48",
    "rentPerYear": "2130.85",
    "securityDeposit": "389.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 152,
    "name": "Events Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.82",
    "description": "This is a description for Events Product 12.",
    "rentPerDay": "0.29",
    "rentPerMonth": "159.06",
    "rentPerYear": "2837.21",
    "securityDeposit": "250.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 153,
    "name": "Events Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "38.05",
    "description": "This is a description for Events Product 13.",
    "rentPerDay": "1.77",
    "rentPerMonth": "215.10",
    "rentPerYear": "3239.54",
    "securityDeposit": "19.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 154,
    "name": "Events Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "91.28",
    "description": "This is a description for Events Product 14.",
    "rentPerDay": "7.65",
    "rentPerMonth": "5.09",
    "rentPerYear": "2199.14",
    "securityDeposit": "183.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 155,
    "name": "Events Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.18",
    "description": "This is a description for Events Product 15.",
    "rentPerDay": "1.97",
    "rentPerMonth": "177.58",
    "rentPerYear": "994.32",
    "securityDeposit": "278.65",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 156,
    "name": "Events Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.63",
    "description": "This is a description for Events Product 16.",
    "rentPerDay": "2.68",
    "rentPerMonth": "171.71",
    "rentPerYear": "1458.74",
    "securityDeposit": "135.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 157,
    "name": "Events Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.64",
    "description": "This is a description for Events Product 17.",
    "rentPerDay": "2.09",
    "rentPerMonth": "132.91",
    "rentPerYear": "2294.81",
    "securityDeposit": "354.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 158,
    "name": "Events Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "64.91",
    "description": "This is a description for Events Product 18.",
    "rentPerDay": "4.39",
    "rentPerMonth": "13.92",
    "rentPerYear": "1485.92",
    "securityDeposit": "133.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 159,
    "name": "Events Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "12.32",
    "description": "This is a description for Events Product 19.",
    "rentPerDay": "7.31",
    "rentPerMonth": "209.43",
    "rentPerYear": "2212.28",
    "securityDeposit": "423.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 160,
    "name": "Events Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "15.48",
    "description": "This is a description for Events Product 20.",
    "rentPerDay": "9.49",
    "rentPerMonth": "55.57",
    "rentPerYear": "933.44",
    "securityDeposit": "53.67",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Events"
  },
  {
    "id": 161,
    "name": "Fitness & Sports Equipment Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.74",
    "description": "This is a description for Fitness & Sports Equipment Product 1.",
    "rentPerDay": "1.29",
    "rentPerMonth": "10.14",
    "rentPerYear": "2189.54",
    "securityDeposit": "480.35",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 162,
    "name": "Fitness & Sports Equipment Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "93.36",
    "description": "This is a description for Fitness & Sports Equipment Product 2.",
    "rentPerDay": "1.88",
    "rentPerMonth": "177.53",
    "rentPerYear": "3376.78",
    "securityDeposit": "306.81",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 163,
    "name": "Fitness & Sports Equipment Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.43",
    "description": "This is a description for Fitness & Sports Equipment Product 3.",
    "rentPerDay": "1.70",
    "rentPerMonth": "264.87",
    "rentPerYear": "2133.53",
    "securityDeposit": "376.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 164,
    "name": "Fitness & Sports Equipment Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "42.86",
    "description": "This is a description for Fitness & Sports Equipment Product 4.",
    "rentPerDay": "8.30",
    "rentPerMonth": "49.16",
    "rentPerYear": "1851.22",
    "securityDeposit": "286.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 165,
    "name": "Fitness & Sports Equipment Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "72.01",
    "description": "This is a description for Fitness & Sports Equipment Product 5.",
    "rentPerDay": "9.67",
    "rentPerMonth": "88.34",
    "rentPerYear": "3323.98",
    "securityDeposit": "284.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 166,
    "name": "Fitness & Sports Equipment Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "12.34",
    "description": "This is a description for Fitness & Sports Equipment Product 6.",
    "rentPerDay": "2.83",
    "rentPerMonth": "86.66",
    "rentPerYear": "3220.29",
    "securityDeposit": "2.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 167,
    "name": "Fitness & Sports Equipment Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.05",
    "description": "This is a description for Fitness & Sports Equipment Product 7.",
    "rentPerDay": "2.35",
    "rentPerMonth": "64.71",
    "rentPerYear": "1394.91",
    "securityDeposit": "200.87",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 168,
    "name": "Fitness & Sports Equipment Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "20.90",
    "description": "This is a description for Fitness & Sports Equipment Product 8.",
    "rentPerDay": "6.97",
    "rentPerMonth": "192.29",
    "rentPerYear": "2764.74",
    "securityDeposit": "182.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 169,
    "name": "Fitness & Sports Equipment Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.46",
    "description": "This is a description for Fitness & Sports Equipment Product 9.",
    "rentPerDay": "6.96",
    "rentPerMonth": "164.64",
    "rentPerYear": "946.83",
    "securityDeposit": "5.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 170,
    "name": "Fitness & Sports Equipment Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "37.69",
    "description": "This is a description for Fitness & Sports Equipment Product 10.",
    "rentPerDay": "3.56",
    "rentPerMonth": "290.04",
    "rentPerYear": "1764.50",
    "securityDeposit": "380.61",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 171,
    "name": "Fitness & Sports Equipment Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "45.81",
    "description": "This is a description for Fitness & Sports Equipment Product 11.",
    "rentPerDay": "1.72",
    "rentPerMonth": "14.58",
    "rentPerYear": "2090.98",
    "securityDeposit": "239.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 172,
    "name": "Fitness & Sports Equipment Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.10",
    "description": "This is a description for Fitness & Sports Equipment Product 12.",
    "rentPerDay": "9.61",
    "rentPerMonth": "172.69",
    "rentPerYear": "108.52",
    "securityDeposit": "268.81",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 173,
    "name": "Fitness & Sports Equipment Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.26",
    "description": "This is a description for Fitness & Sports Equipment Product 13.",
    "rentPerDay": "5.41",
    "rentPerMonth": "182.25",
    "rentPerYear": "2565.93",
    "securityDeposit": "87.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 174,
    "name": "Fitness & Sports Equipment Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.09",
    "description": "This is a description for Fitness & Sports Equipment Product 14.",
    "rentPerDay": "3.29",
    "rentPerMonth": "231.33",
    "rentPerYear": "1744.61",
    "securityDeposit": "107.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 175,
    "name": "Fitness & Sports Equipment Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.46",
    "description": "This is a description for Fitness & Sports Equipment Product 15.",
    "rentPerDay": "7.57",
    "rentPerMonth": "121.29",
    "rentPerYear": "871.49",
    "securityDeposit": "150.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 176,
    "name": "Fitness & Sports Equipment Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "99.02",
    "description": "This is a description for Fitness & Sports Equipment Product 16.",
    "rentPerDay": "5.04",
    "rentPerMonth": "180.56",
    "rentPerYear": "3522.71",
    "securityDeposit": "443.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 177,
    "name": "Fitness & Sports Equipment Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "4.96",
    "description": "This is a description for Fitness & Sports Equipment Product 17.",
    "rentPerDay": "6.52",
    "rentPerMonth": "188.20",
    "rentPerYear": "350.30",
    "securityDeposit": "70.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 178,
    "name": "Fitness & Sports Equipment Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.43",
    "description": "This is a description for Fitness & Sports Equipment Product 18.",
    "rentPerDay": "1.86",
    "rentPerMonth": "180.48",
    "rentPerYear": "498.96",
    "securityDeposit": "491.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 179,
    "name": "Fitness & Sports Equipment Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.74",
    "description": "This is a description for Fitness & Sports Equipment Product 19.",
    "rentPerDay": "6.59",
    "rentPerMonth": "241.02",
    "rentPerYear": "2031.14",
    "securityDeposit": "27.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 180,
    "name": "Fitness & Sports Equipment Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "12.33",
    "description": "This is a description for Fitness & Sports Equipment Product 20.",
    "rentPerDay": "1.39",
    "rentPerMonth": "117.19",
    "rentPerYear": "29.10",
    "securityDeposit": "70.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Fitness & Sports Equipment"
  },
  {
    "id": 181,
    "name": "Furniture Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.71",
    "description": "This is a description for Furniture Product 1.",
    "rentPerDay": "8.22",
    "rentPerMonth": "220.98",
    "rentPerYear": "1122.50",
    "securityDeposit": "92.00",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 182,
    "name": "Furniture Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "90.52",
    "description": "This is a description for Furniture Product 2.",
    "rentPerDay": "3.65",
    "rentPerMonth": "188.26",
    "rentPerYear": "345.36",
    "securityDeposit": "57.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 183,
    "name": "Furniture Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.67",
    "description": "This is a description for Furniture Product 3.",
    "rentPerDay": "4.85",
    "rentPerMonth": "65.92",
    "rentPerYear": "880.55",
    "securityDeposit": "19.18",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 184,
    "name": "Furniture Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.23",
    "description": "This is a description for Furniture Product 4.",
    "rentPerDay": "2.07",
    "rentPerMonth": "280.73",
    "rentPerYear": "1121.57",
    "securityDeposit": "135.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 185,
    "name": "Furniture Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.50",
    "description": "This is a description for Furniture Product 5.",
    "rentPerDay": "8.30",
    "rentPerMonth": "29.99",
    "rentPerYear": "3404.26",
    "securityDeposit": "226.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 186,
    "name": "Furniture Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.77",
    "description": "This is a description for Furniture Product 6.",
    "rentPerDay": "9.37",
    "rentPerMonth": "84.92",
    "rentPerYear": "703.31",
    "securityDeposit": "200.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 187,
    "name": "Furniture Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.91",
    "description": "This is a description for Furniture Product 7.",
    "rentPerDay": "1.28",
    "rentPerMonth": "281.54",
    "rentPerYear": "3373.51",
    "securityDeposit": "232.31",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 188,
    "name": "Furniture Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.46",
    "description": "This is a description for Furniture Product 8.",
    "rentPerDay": "6.78",
    "rentPerMonth": "161.93",
    "rentPerYear": "39.38",
    "securityDeposit": "378.30",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 189,
    "name": "Furniture Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "50.16",
    "description": "This is a description for Furniture Product 9.",
    "rentPerDay": "5.86",
    "rentPerMonth": "193.73",
    "rentPerYear": "1667.72",
    "securityDeposit": "71.11",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 190,
    "name": "Furniture Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "45.13",
    "description": "This is a description for Furniture Product 10.",
    "rentPerDay": "9.43",
    "rentPerMonth": "249.97",
    "rentPerYear": "88.10",
    "securityDeposit": "113.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 191,
    "name": "Furniture Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "17.29",
    "description": "This is a description for Furniture Product 11.",
    "rentPerDay": "7.81",
    "rentPerMonth": "110.04",
    "rentPerYear": "3332.84",
    "securityDeposit": "132.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 192,
    "name": "Furniture Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.55",
    "description": "This is a description for Furniture Product 12.",
    "rentPerDay": "6.50",
    "rentPerMonth": "65.77",
    "rentPerYear": "3120.93",
    "securityDeposit": "283.13",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 193,
    "name": "Furniture Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.51",
    "description": "This is a description for Furniture Product 13.",
    "rentPerDay": "8.74",
    "rentPerMonth": "145.72",
    "rentPerYear": "213.14",
    "securityDeposit": "184.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 194,
    "name": "Furniture Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.79",
    "description": "This is a description for Furniture Product 14.",
    "rentPerDay": "3.22",
    "rentPerMonth": "134.71",
    "rentPerYear": "1626.37",
    "securityDeposit": "286.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 195,
    "name": "Furniture Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "81.61",
    "description": "This is a description for Furniture Product 15.",
    "rentPerDay": "3.23",
    "rentPerMonth": "224.79",
    "rentPerYear": "680.72",
    "securityDeposit": "196.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 196,
    "name": "Furniture Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "0.50",
    "description": "This is a description for Furniture Product 16.",
    "rentPerDay": "6.03",
    "rentPerMonth": "130.18",
    "rentPerYear": "1217.38",
    "securityDeposit": "394.18",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 197,
    "name": "Furniture Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.37",
    "description": "This is a description for Furniture Product 17.",
    "rentPerDay": "4.73",
    "rentPerMonth": "18.42",
    "rentPerYear": "72.12",
    "securityDeposit": "115.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 198,
    "name": "Furniture Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "16.44",
    "description": "This is a description for Furniture Product 18.",
    "rentPerDay": "6.00",
    "rentPerMonth": "248.83",
    "rentPerYear": "2055.14",
    "securityDeposit": "493.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 199,
    "name": "Furniture Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "4.81",
    "description": "This is a description for Furniture Product 19.",
    "rentPerDay": "2.55",
    "rentPerMonth": "228.46",
    "rentPerYear": "1875.69",
    "securityDeposit": "215.38",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 200,
    "name": "Furniture Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.77",
    "description": "This is a description for Furniture Product 20.",
    "rentPerDay": "2.27",
    "rentPerMonth": "264.48",
    "rentPerYear": "2121.50",
    "securityDeposit": "279.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Furniture"
  },
  {
    "id": 201,
    "name": "Gardening Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.82",
    "description": "This is a description for Gardening Product 1.",
    "rentPerDay": "1.85",
    "rentPerMonth": "123.40",
    "rentPerYear": "349.08",
    "securityDeposit": "367.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 202,
    "name": "Gardening Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "44.65",
    "description": "This is a description for Gardening Product 2.",
    "rentPerDay": "3.84",
    "rentPerMonth": "183.58",
    "rentPerYear": "2186.87",
    "securityDeposit": "234.09",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 203,
    "name": "Gardening Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.97",
    "description": "This is a description for Gardening Product 3.",
    "rentPerDay": "1.49",
    "rentPerMonth": "54.80",
    "rentPerYear": "220.82",
    "securityDeposit": "41.67",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 204,
    "name": "Gardening Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.55",
    "description": "This is a description for Gardening Product 4.",
    "rentPerDay": "2.95",
    "rentPerMonth": "33.08",
    "rentPerYear": "2182.95",
    "securityDeposit": "326.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 205,
    "name": "Gardening Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "79.12",
    "description": "This is a description for Gardening Product 5.",
    "rentPerDay": "6.45",
    "rentPerMonth": "207.67",
    "rentPerYear": "250.29",
    "securityDeposit": "142.79",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 206,
    "name": "Gardening Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.90",
    "description": "This is a description for Gardening Product 6.",
    "rentPerDay": "9.95",
    "rentPerMonth": "284.18",
    "rentPerYear": "1433.14",
    "securityDeposit": "419.30",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 207,
    "name": "Gardening Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.98",
    "description": "This is a description for Gardening Product 7.",
    "rentPerDay": "8.43",
    "rentPerMonth": "143.07",
    "rentPerYear": "1348.56",
    "securityDeposit": "217.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 208,
    "name": "Gardening Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "71.98",
    "description": "This is a description for Gardening Product 8.",
    "rentPerDay": "4.52",
    "rentPerMonth": "50.14",
    "rentPerYear": "1871.85",
    "securityDeposit": "343.90",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 209,
    "name": "Gardening Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "83.25",
    "description": "This is a description for Gardening Product 9.",
    "rentPerDay": "7.89",
    "rentPerMonth": "173.22",
    "rentPerYear": "2116.03",
    "securityDeposit": "291.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 210,
    "name": "Gardening Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "52.19",
    "description": "This is a description for Gardening Product 10.",
    "rentPerDay": "5.30",
    "rentPerMonth": "67.86",
    "rentPerYear": "1626.14",
    "securityDeposit": "32.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 211,
    "name": "Gardening Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "34.84",
    "description": "This is a description for Gardening Product 11.",
    "rentPerDay": "6.44",
    "rentPerMonth": "165.49",
    "rentPerYear": "308.34",
    "securityDeposit": "64.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 212,
    "name": "Gardening Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.40",
    "description": "This is a description for Gardening Product 12.",
    "rentPerDay": "6.49",
    "rentPerMonth": "3.33",
    "rentPerYear": "711.66",
    "securityDeposit": "49.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 213,
    "name": "Gardening Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.40",
    "description": "This is a description for Gardening Product 13.",
    "rentPerDay": "9.93",
    "rentPerMonth": "185.97",
    "rentPerYear": "1311.98",
    "securityDeposit": "363.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 214,
    "name": "Gardening Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "42.85",
    "description": "This is a description for Gardening Product 14.",
    "rentPerDay": "4.84",
    "rentPerMonth": "69.84",
    "rentPerYear": "2869.51",
    "securityDeposit": "211.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 215,
    "name": "Gardening Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "38.08",
    "description": "This is a description for Gardening Product 15.",
    "rentPerDay": "7.35",
    "rentPerMonth": "234.03",
    "rentPerYear": "35.03",
    "securityDeposit": "53.97",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 216,
    "name": "Gardening Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.75",
    "description": "This is a description for Gardening Product 16.",
    "rentPerDay": "7.97",
    "rentPerMonth": "211.68",
    "rentPerYear": "778.74",
    "securityDeposit": "320.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 217,
    "name": "Gardening Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "37.80",
    "description": "This is a description for Gardening Product 17.",
    "rentPerDay": "6.28",
    "rentPerMonth": "147.37",
    "rentPerYear": "2288.57",
    "securityDeposit": "201.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 218,
    "name": "Gardening Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.38",
    "description": "This is a description for Gardening Product 18.",
    "rentPerDay": "9.16",
    "rentPerMonth": "56.35",
    "rentPerYear": "1338.99",
    "securityDeposit": "365.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 219,
    "name": "Gardening Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.03",
    "description": "This is a description for Gardening Product 19.",
    "rentPerDay": "1.37",
    "rentPerMonth": "200.13",
    "rentPerYear": "341.57",
    "securityDeposit": "359.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 220,
    "name": "Gardening Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.27",
    "description": "This is a description for Gardening Product 20.",
    "rentPerDay": "7.22",
    "rentPerMonth": "128.71",
    "rentPerYear": "2732.45",
    "securityDeposit": "235.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Gardening"
  },
  {
    "id": 221,
    "name": "Generators Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "81.35",
    "description": "This is a description for Generators Product 1.",
    "rentPerDay": "2.41",
    "rentPerMonth": "174.43",
    "rentPerYear": "2479.25",
    "securityDeposit": "346.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 222,
    "name": "Generators Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.17",
    "description": "This is a description for Generators Product 2.",
    "rentPerDay": "8.57",
    "rentPerMonth": "15.84",
    "rentPerYear": "3231.63",
    "securityDeposit": "72.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 223,
    "name": "Generators Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.24",
    "description": "This is a description for Generators Product 3.",
    "rentPerDay": "6.25",
    "rentPerMonth": "150.91",
    "rentPerYear": "96.61",
    "securityDeposit": "153.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 224,
    "name": "Generators Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.90",
    "description": "This is a description for Generators Product 4.",
    "rentPerDay": "9.82",
    "rentPerMonth": "3.05",
    "rentPerYear": "1517.98",
    "securityDeposit": "232.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 225,
    "name": "Generators Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.06",
    "description": "This is a description for Generators Product 5.",
    "rentPerDay": "8.17",
    "rentPerMonth": "140.90",
    "rentPerYear": "1555.32",
    "securityDeposit": "408.73",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 226,
    "name": "Generators Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "76.81",
    "description": "This is a description for Generators Product 6.",
    "rentPerDay": "2.15",
    "rentPerMonth": "34.47",
    "rentPerYear": "2581.13",
    "securityDeposit": "452.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 227,
    "name": "Generators Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.00",
    "description": "This is a description for Generators Product 7.",
    "rentPerDay": "8.86",
    "rentPerMonth": "19.15",
    "rentPerYear": "775.58",
    "securityDeposit": "393.79",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 228,
    "name": "Generators Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.84",
    "description": "This is a description for Generators Product 8.",
    "rentPerDay": "3.28",
    "rentPerMonth": "228.01",
    "rentPerYear": "54.49",
    "securityDeposit": "471.51",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 229,
    "name": "Generators Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.23",
    "description": "This is a description for Generators Product 9.",
    "rentPerDay": "1.20",
    "rentPerMonth": "262.33",
    "rentPerYear": "3519.27",
    "securityDeposit": "267.73",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 230,
    "name": "Generators Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "52.16",
    "description": "This is a description for Generators Product 10.",
    "rentPerDay": "8.06",
    "rentPerMonth": "181.26",
    "rentPerYear": "3464.52",
    "securityDeposit": "110.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 231,
    "name": "Generators Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.62",
    "description": "This is a description for Generators Product 11.",
    "rentPerDay": "8.86",
    "rentPerMonth": "194.01",
    "rentPerYear": "1951.10",
    "securityDeposit": "424.90",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 232,
    "name": "Generators Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "4.97",
    "description": "This is a description for Generators Product 12.",
    "rentPerDay": "1.12",
    "rentPerMonth": "163.13",
    "rentPerYear": "2915.73",
    "securityDeposit": "87.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 233,
    "name": "Generators Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.84",
    "description": "This is a description for Generators Product 13.",
    "rentPerDay": "5.94",
    "rentPerMonth": "35.83",
    "rentPerYear": "40.28",
    "securityDeposit": "29.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 234,
    "name": "Generators Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.59",
    "description": "This is a description for Generators Product 14.",
    "rentPerDay": "6.82",
    "rentPerMonth": "285.18",
    "rentPerYear": "439.67",
    "securityDeposit": "313.45",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 235,
    "name": "Generators Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.97",
    "description": "This is a description for Generators Product 15.",
    "rentPerDay": "6.05",
    "rentPerMonth": "143.02",
    "rentPerYear": "2472.84",
    "securityDeposit": "333.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 236,
    "name": "Generators Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "27.33",
    "description": "This is a description for Generators Product 16.",
    "rentPerDay": "8.46",
    "rentPerMonth": "209.03",
    "rentPerYear": "831.40",
    "securityDeposit": "400.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 237,
    "name": "Generators Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.90",
    "description": "This is a description for Generators Product 17.",
    "rentPerDay": "2.51",
    "rentPerMonth": "295.78",
    "rentPerYear": "86.67",
    "securityDeposit": "229.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 238,
    "name": "Generators Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.87",
    "description": "This is a description for Generators Product 18.",
    "rentPerDay": "5.86",
    "rentPerMonth": "58.90",
    "rentPerYear": "2201.86",
    "securityDeposit": "44.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 239,
    "name": "Generators Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.93",
    "description": "This is a description for Generators Product 19.",
    "rentPerDay": "9.06",
    "rentPerMonth": "140.62",
    "rentPerYear": "1042.30",
    "securityDeposit": "325.02",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 240,
    "name": "Generators Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.13",
    "description": "This is a description for Generators Product 20.",
    "rentPerDay": "8.27",
    "rentPerMonth": "29.21",
    "rentPerYear": "2184.32",
    "securityDeposit": "86.18",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Generators"
  },
  {
    "id": 241,
    "name": "Home Appliance Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "50.86",
    "description": "This is a description for Home Appliance Product 1.",
    "rentPerDay": "7.12",
    "rentPerMonth": "284.02",
    "rentPerYear": "1502.29",
    "securityDeposit": "180.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 242,
    "name": "Home Appliance Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "51.93",
    "description": "This is a description for Home Appliance Product 2.",
    "rentPerDay": "9.97",
    "rentPerMonth": "232.00",
    "rentPerYear": "2565.54",
    "securityDeposit": "290.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 243,
    "name": "Home Appliance Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "79.16",
    "description": "This is a description for Home Appliance Product 3.",
    "rentPerDay": "5.69",
    "rentPerMonth": "173.54",
    "rentPerYear": "72.15",
    "securityDeposit": "327.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 244,
    "name": "Home Appliance Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "15.68",
    "description": "This is a description for Home Appliance Product 4.",
    "rentPerDay": "8.22",
    "rentPerMonth": "100.94",
    "rentPerYear": "2532.57",
    "securityDeposit": "208.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 245,
    "name": "Home Appliance Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.76",
    "description": "This is a description for Home Appliance Product 5.",
    "rentPerDay": "9.09",
    "rentPerMonth": "93.49",
    "rentPerYear": "2891.70",
    "securityDeposit": "87.73",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 246,
    "name": "Home Appliance Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.73",
    "description": "This is a description for Home Appliance Product 6.",
    "rentPerDay": "7.28",
    "rentPerMonth": "138.03",
    "rentPerYear": "3287.66",
    "securityDeposit": "340.78",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 247,
    "name": "Home Appliance Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.68",
    "description": "This is a description for Home Appliance Product 7.",
    "rentPerDay": "9.53",
    "rentPerMonth": "172.54",
    "rentPerYear": "1017.26",
    "securityDeposit": "94.82",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 248,
    "name": "Home Appliance Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "35.40",
    "description": "This is a description for Home Appliance Product 8.",
    "rentPerDay": "1.62",
    "rentPerMonth": "293.27",
    "rentPerYear": "3269.89",
    "securityDeposit": "248.78",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 249,
    "name": "Home Appliance Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.98",
    "description": "This is a description for Home Appliance Product 9.",
    "rentPerDay": "8.77",
    "rentPerMonth": "110.99",
    "rentPerYear": "2906.85",
    "securityDeposit": "338.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 250,
    "name": "Home Appliance Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "62.89",
    "description": "This is a description for Home Appliance Product 10.",
    "rentPerDay": "0.67",
    "rentPerMonth": "151.88",
    "rentPerYear": "2324.06",
    "securityDeposit": "128.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 251,
    "name": "Home Appliance Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.84",
    "description": "This is a description for Home Appliance Product 11.",
    "rentPerDay": "1.02",
    "rentPerMonth": "276.94",
    "rentPerYear": "3319.17",
    "securityDeposit": "391.07",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 252,
    "name": "Home Appliance Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.90",
    "description": "This is a description for Home Appliance Product 12.",
    "rentPerDay": "9.53",
    "rentPerMonth": "42.49",
    "rentPerYear": "701.30",
    "securityDeposit": "42.79",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 253,
    "name": "Home Appliance Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "55.65",
    "description": "This is a description for Home Appliance Product 13.",
    "rentPerDay": "6.59",
    "rentPerMonth": "37.98",
    "rentPerYear": "2415.36",
    "securityDeposit": "74.53",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 254,
    "name": "Home Appliance Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "93.40",
    "description": "This is a description for Home Appliance Product 14.",
    "rentPerDay": "8.98",
    "rentPerMonth": "35.89",
    "rentPerYear": "1796.46",
    "securityDeposit": "80.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 255,
    "name": "Home Appliance Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "65.52",
    "description": "This is a description for Home Appliance Product 15.",
    "rentPerDay": "0.34",
    "rentPerMonth": "143.26",
    "rentPerYear": "1032.52",
    "securityDeposit": "298.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 256,
    "name": "Home Appliance Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.99",
    "description": "This is a description for Home Appliance Product 16.",
    "rentPerDay": "0.17",
    "rentPerMonth": "260.19",
    "rentPerYear": "1226.10",
    "securityDeposit": "471.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 257,
    "name": "Home Appliance Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.56",
    "description": "This is a description for Home Appliance Product 17.",
    "rentPerDay": "2.28",
    "rentPerMonth": "297.93",
    "rentPerYear": "3438.42",
    "securityDeposit": "469.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 258,
    "name": "Home Appliance Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.30",
    "description": "This is a description for Home Appliance Product 18.",
    "rentPerDay": "7.27",
    "rentPerMonth": "190.82",
    "rentPerYear": "1081.34",
    "securityDeposit": "216.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 259,
    "name": "Home Appliance Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.27",
    "description": "This is a description for Home Appliance Product 19.",
    "rentPerDay": "2.62",
    "rentPerMonth": "48.39",
    "rentPerYear": "1195.59",
    "securityDeposit": "449.44",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 260,
    "name": "Home Appliance Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.24",
    "description": "This is a description for Home Appliance Product 20.",
    "rentPerDay": "0.93",
    "rentPerMonth": "100.26",
    "rentPerYear": "1758.11",
    "securityDeposit": "130.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Home Appliance"
  },
  {
    "id": 261,
    "name": "Jewellery Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.77",
    "description": "This is a description for Jewellery Product 1.",
    "rentPerDay": "1.59",
    "rentPerMonth": "205.58",
    "rentPerYear": "213.93",
    "securityDeposit": "440.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 262,
    "name": "Jewellery Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.00",
    "description": "This is a description for Jewellery Product 2.",
    "rentPerDay": "3.32",
    "rentPerMonth": "9.55",
    "rentPerYear": "2074.51",
    "securityDeposit": "240.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 263,
    "name": "Jewellery Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "63.81",
    "description": "This is a description for Jewellery Product 3.",
    "rentPerDay": "9.31",
    "rentPerMonth": "24.95",
    "rentPerYear": "3457.79",
    "securityDeposit": "115.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 264,
    "name": "Jewellery Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.76",
    "description": "This is a description for Jewellery Product 4.",
    "rentPerDay": "9.23",
    "rentPerMonth": "290.91",
    "rentPerYear": "3548.02",
    "securityDeposit": "123.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 265,
    "name": "Jewellery Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.57",
    "description": "This is a description for Jewellery Product 5.",
    "rentPerDay": "9.77",
    "rentPerMonth": "35.96",
    "rentPerYear": "1791.14",
    "securityDeposit": "312.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 266,
    "name": "Jewellery Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "95.53",
    "description": "This is a description for Jewellery Product 6.",
    "rentPerDay": "4.27",
    "rentPerMonth": "11.50",
    "rentPerYear": "1897.78",
    "securityDeposit": "370.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 267,
    "name": "Jewellery Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.98",
    "description": "This is a description for Jewellery Product 7.",
    "rentPerDay": "8.74",
    "rentPerMonth": "266.57",
    "rentPerYear": "2703.39",
    "securityDeposit": "35.59",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 268,
    "name": "Jewellery Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.17",
    "description": "This is a description for Jewellery Product 8.",
    "rentPerDay": "4.12",
    "rentPerMonth": "100.51",
    "rentPerYear": "3552.01",
    "securityDeposit": "483.83",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 269,
    "name": "Jewellery Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.43",
    "description": "This is a description for Jewellery Product 9.",
    "rentPerDay": "7.50",
    "rentPerMonth": "193.32",
    "rentPerYear": "264.41",
    "securityDeposit": "279.11",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 270,
    "name": "Jewellery Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.36",
    "description": "This is a description for Jewellery Product 10.",
    "rentPerDay": "9.65",
    "rentPerMonth": "246.74",
    "rentPerYear": "1673.41",
    "securityDeposit": "389.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 271,
    "name": "Jewellery Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "93.66",
    "description": "This is a description for Jewellery Product 11.",
    "rentPerDay": "1.56",
    "rentPerMonth": "51.55",
    "rentPerYear": "558.11",
    "securityDeposit": "261.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 272,
    "name": "Jewellery Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.96",
    "description": "This is a description for Jewellery Product 12.",
    "rentPerDay": "9.82",
    "rentPerMonth": "192.71",
    "rentPerYear": "2989.68",
    "securityDeposit": "24.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 273,
    "name": "Jewellery Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.72",
    "description": "This is a description for Jewellery Product 13.",
    "rentPerDay": "1.43",
    "rentPerMonth": "19.95",
    "rentPerYear": "2026.95",
    "securityDeposit": "102.96",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 274,
    "name": "Jewellery Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.83",
    "description": "This is a description for Jewellery Product 14.",
    "rentPerDay": "2.96",
    "rentPerMonth": "293.60",
    "rentPerYear": "2707.23",
    "securityDeposit": "312.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 275,
    "name": "Jewellery Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "92.49",
    "description": "This is a description for Jewellery Product 15.",
    "rentPerDay": "8.26",
    "rentPerMonth": "50.70",
    "rentPerYear": "393.58",
    "securityDeposit": "181.44",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 276,
    "name": "Jewellery Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.75",
    "description": "This is a description for Jewellery Product 16.",
    "rentPerDay": "7.46",
    "rentPerMonth": "202.58",
    "rentPerYear": "57.54",
    "securityDeposit": "21.89",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 277,
    "name": "Jewellery Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.16",
    "description": "This is a description for Jewellery Product 17.",
    "rentPerDay": "4.69",
    "rentPerMonth": "3.50",
    "rentPerYear": "2513.48",
    "securityDeposit": "190.13",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 278,
    "name": "Jewellery Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "81.83",
    "description": "This is a description for Jewellery Product 18.",
    "rentPerDay": "1.78",
    "rentPerMonth": "172.30",
    "rentPerYear": "1883.35",
    "securityDeposit": "64.93",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 279,
    "name": "Jewellery Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.48",
    "description": "This is a description for Jewellery Product 19.",
    "rentPerDay": "9.03",
    "rentPerMonth": "152.78",
    "rentPerYear": "1422.33",
    "securityDeposit": "107.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 280,
    "name": "Jewellery Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.37",
    "description": "This is a description for Jewellery Product 20.",
    "rentPerDay": "8.13",
    "rentPerMonth": "291.26",
    "rentPerYear": "2139.97",
    "securityDeposit": "42.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Jewellery"
  },
  {
    "id": 281,
    "name": "Kids Utilities Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "19.67",
    "description": "This is a description for Kids Utilities Product 1.",
    "rentPerDay": "4.55",
    "rentPerMonth": "285.28",
    "rentPerYear": "1768.14",
    "securityDeposit": "442.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 282,
    "name": "Kids Utilities Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.18",
    "description": "This is a description for Kids Utilities Product 2.",
    "rentPerDay": "1.68",
    "rentPerMonth": "78.61",
    "rentPerYear": "1354.10",
    "securityDeposit": "278.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 283,
    "name": "Kids Utilities Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.11",
    "description": "This is a description for Kids Utilities Product 3.",
    "rentPerDay": "2.85",
    "rentPerMonth": "150.13",
    "rentPerYear": "1514.44",
    "securityDeposit": "229.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 284,
    "name": "Kids Utilities Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.78",
    "description": "This is a description for Kids Utilities Product 4.",
    "rentPerDay": "5.39",
    "rentPerMonth": "162.52",
    "rentPerYear": "1611.98",
    "securityDeposit": "352.45",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 285,
    "name": "Kids Utilities Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "18.09",
    "description": "This is a description for Kids Utilities Product 5.",
    "rentPerDay": "6.20",
    "rentPerMonth": "229.89",
    "rentPerYear": "2631.85",
    "securityDeposit": "415.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 286,
    "name": "Kids Utilities Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.00",
    "description": "This is a description for Kids Utilities Product 6.",
    "rentPerDay": "6.99",
    "rentPerMonth": "276.15",
    "rentPerYear": "2865.04",
    "securityDeposit": "113.23",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 287,
    "name": "Kids Utilities Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.82",
    "description": "This is a description for Kids Utilities Product 7.",
    "rentPerDay": "2.01",
    "rentPerMonth": "161.20",
    "rentPerYear": "1102.47",
    "securityDeposit": "220.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 288,
    "name": "Kids Utilities Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "17.64",
    "description": "This is a description for Kids Utilities Product 8.",
    "rentPerDay": "5.58",
    "rentPerMonth": "293.58",
    "rentPerYear": "2662.96",
    "securityDeposit": "141.61",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 289,
    "name": "Kids Utilities Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "64.77",
    "description": "This is a description for Kids Utilities Product 9.",
    "rentPerDay": "6.50",
    "rentPerMonth": "273.85",
    "rentPerYear": "3495.87",
    "securityDeposit": "471.95",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 290,
    "name": "Kids Utilities Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "91.71",
    "description": "This is a description for Kids Utilities Product 10.",
    "rentPerDay": "5.14",
    "rentPerMonth": "197.64",
    "rentPerYear": "2534.66",
    "securityDeposit": "427.96",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 291,
    "name": "Kids Utilities Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "1.18",
    "description": "This is a description for Kids Utilities Product 11.",
    "rentPerDay": "5.46",
    "rentPerMonth": "222.54",
    "rentPerYear": "1880.58",
    "securityDeposit": "346.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 292,
    "name": "Kids Utilities Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.06",
    "description": "This is a description for Kids Utilities Product 12.",
    "rentPerDay": "5.26",
    "rentPerMonth": "95.01",
    "rentPerYear": "1591.44",
    "securityDeposit": "82.49",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 293,
    "name": "Kids Utilities Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.79",
    "description": "This is a description for Kids Utilities Product 13.",
    "rentPerDay": "8.37",
    "rentPerMonth": "232.90",
    "rentPerYear": "2058.69",
    "securityDeposit": "226.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 294,
    "name": "Kids Utilities Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.91",
    "description": "This is a description for Kids Utilities Product 14.",
    "rentPerDay": "5.53",
    "rentPerMonth": "297.25",
    "rentPerYear": "3421.27",
    "securityDeposit": "187.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 295,
    "name": "Kids Utilities Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "40.61",
    "description": "This is a description for Kids Utilities Product 15.",
    "rentPerDay": "3.81",
    "rentPerMonth": "266.12",
    "rentPerYear": "3277.64",
    "securityDeposit": "1.87",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 296,
    "name": "Kids Utilities Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.55",
    "description": "This is a description for Kids Utilities Product 16.",
    "rentPerDay": "9.32",
    "rentPerMonth": "9.07",
    "rentPerYear": "1233.58",
    "securityDeposit": "407.29",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 297,
    "name": "Kids Utilities Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.46",
    "description": "This is a description for Kids Utilities Product 17.",
    "rentPerDay": "0.93",
    "rentPerMonth": "155.08",
    "rentPerYear": "3491.76",
    "securityDeposit": "321.47",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 298,
    "name": "Kids Utilities Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.83",
    "description": "This is a description for Kids Utilities Product 18.",
    "rentPerDay": "4.34",
    "rentPerMonth": "95.28",
    "rentPerYear": "2060.27",
    "securityDeposit": "203.75",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 299,
    "name": "Kids Utilities Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.93",
    "description": "This is a description for Kids Utilities Product 19.",
    "rentPerDay": "2.73",
    "rentPerMonth": "140.84",
    "rentPerYear": "2118.51",
    "securityDeposit": "265.16",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 300,
    "name": "Kids Utilities Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "27.55",
    "description": "This is a description for Kids Utilities Product 20.",
    "rentPerDay": "9.52",
    "rentPerMonth": "156.76",
    "rentPerYear": "2989.03",
    "securityDeposit": "481.49",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Kids Utilities"
  },
  {
    "id": 301,
    "name": "Machines & Tools Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.76",
    "description": "This is a description for Machines & Tools Product 1.",
    "rentPerDay": "8.32",
    "rentPerMonth": "165.27",
    "rentPerYear": "821.94",
    "securityDeposit": "134.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 302,
    "name": "Machines & Tools Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.42",
    "description": "This is a description for Machines & Tools Product 2.",
    "rentPerDay": "2.45",
    "rentPerMonth": "209.86",
    "rentPerYear": "464.78",
    "securityDeposit": "186.13",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 303,
    "name": "Machines & Tools Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "44.57",
    "description": "This is a description for Machines & Tools Product 3.",
    "rentPerDay": "3.80",
    "rentPerMonth": "97.64",
    "rentPerYear": "3484.64",
    "securityDeposit": "167.29",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 304,
    "name": "Machines & Tools Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "19.27",
    "description": "This is a description for Machines & Tools Product 4.",
    "rentPerDay": "6.43",
    "rentPerMonth": "240.84",
    "rentPerYear": "2288.39",
    "securityDeposit": "282.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 305,
    "name": "Machines & Tools Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.04",
    "description": "This is a description for Machines & Tools Product 5.",
    "rentPerDay": "0.21",
    "rentPerMonth": "211.37",
    "rentPerYear": "2084.04",
    "securityDeposit": "28.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 306,
    "name": "Machines & Tools Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.35",
    "description": "This is a description for Machines & Tools Product 6.",
    "rentPerDay": "2.37",
    "rentPerMonth": "218.55",
    "rentPerYear": "1526.99",
    "securityDeposit": "204.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 307,
    "name": "Machines & Tools Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.05",
    "description": "This is a description for Machines & Tools Product 7.",
    "rentPerDay": "5.19",
    "rentPerMonth": "165.31",
    "rentPerYear": "2597.66",
    "securityDeposit": "459.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 308,
    "name": "Machines & Tools Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.26",
    "description": "This is a description for Machines & Tools Product 8.",
    "rentPerDay": "8.46",
    "rentPerMonth": "95.35",
    "rentPerYear": "236.08",
    "securityDeposit": "299.97",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 309,
    "name": "Machines & Tools Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.21",
    "description": "This is a description for Machines & Tools Product 9.",
    "rentPerDay": "7.72",
    "rentPerMonth": "180.77",
    "rentPerYear": "1411.51",
    "securityDeposit": "215.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 310,
    "name": "Machines & Tools Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.54",
    "description": "This is a description for Machines & Tools Product 10.",
    "rentPerDay": "9.74",
    "rentPerMonth": "113.36",
    "rentPerYear": "1894.95",
    "securityDeposit": "154.73",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 311,
    "name": "Machines & Tools Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.61",
    "description": "This is a description for Machines & Tools Product 11.",
    "rentPerDay": "4.35",
    "rentPerMonth": "64.92",
    "rentPerYear": "3382.08",
    "securityDeposit": "192.44",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 312,
    "name": "Machines & Tools Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "35.31",
    "description": "This is a description for Machines & Tools Product 12.",
    "rentPerDay": "1.88",
    "rentPerMonth": "88.04",
    "rentPerYear": "2263.82",
    "securityDeposit": "342.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 313,
    "name": "Machines & Tools Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.43",
    "description": "This is a description for Machines & Tools Product 13.",
    "rentPerDay": "9.12",
    "rentPerMonth": "177.73",
    "rentPerYear": "2423.93",
    "securityDeposit": "112.17",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 314,
    "name": "Machines & Tools Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.30",
    "description": "This is a description for Machines & Tools Product 14.",
    "rentPerDay": "2.29",
    "rentPerMonth": "283.38",
    "rentPerYear": "599.54",
    "securityDeposit": "189.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 315,
    "name": "Machines & Tools Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "37.26",
    "description": "This is a description for Machines & Tools Product 15.",
    "rentPerDay": "4.71",
    "rentPerMonth": "99.12",
    "rentPerYear": "1963.88",
    "securityDeposit": "349.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 316,
    "name": "Machines & Tools Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.32",
    "description": "This is a description for Machines & Tools Product 16.",
    "rentPerDay": "5.65",
    "rentPerMonth": "164.49",
    "rentPerYear": "2641.02",
    "securityDeposit": "148.28",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 317,
    "name": "Machines & Tools Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.27",
    "description": "This is a description for Machines & Tools Product 17.",
    "rentPerDay": "5.75",
    "rentPerMonth": "130.63",
    "rentPerYear": "539.51",
    "securityDeposit": "442.54",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 318,
    "name": "Machines & Tools Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.23",
    "description": "This is a description for Machines & Tools Product 18.",
    "rentPerDay": "9.11",
    "rentPerMonth": "73.49",
    "rentPerYear": "2549.10",
    "securityDeposit": "240.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 319,
    "name": "Machines & Tools Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "48.96",
    "description": "This is a description for Machines & Tools Product 19.",
    "rentPerDay": "2.40",
    "rentPerMonth": "91.69",
    "rentPerYear": "38.55",
    "securityDeposit": "358.02",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 320,
    "name": "Machines & Tools Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "20.80",
    "description": "This is a description for Machines & Tools Product 20.",
    "rentPerDay": "4.56",
    "rentPerMonth": "11.26",
    "rentPerYear": "466.79",
    "securityDeposit": "227.13",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Machines & Tools"
  },
  {
    "id": 321,
    "name": "Medical Equipment & Services Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "83.42",
    "description": "This is a description for Medical Equipment & Services Product 1.",
    "rentPerDay": "2.34",
    "rentPerMonth": "280.40",
    "rentPerYear": "2298.95",
    "securityDeposit": "173.27",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 322,
    "name": "Medical Equipment & Services Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.37",
    "description": "This is a description for Medical Equipment & Services Product 2.",
    "rentPerDay": "2.64",
    "rentPerMonth": "20.10",
    "rentPerYear": "1265.01",
    "securityDeposit": "111.92",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 323,
    "name": "Medical Equipment & Services Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.76",
    "description": "This is a description for Medical Equipment & Services Product 3.",
    "rentPerDay": "7.67",
    "rentPerMonth": "252.76",
    "rentPerYear": "20.19",
    "securityDeposit": "74.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 324,
    "name": "Medical Equipment & Services Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "87.60",
    "description": "This is a description for Medical Equipment & Services Product 4.",
    "rentPerDay": "8.85",
    "rentPerMonth": "191.97",
    "rentPerYear": "1411.95",
    "securityDeposit": "51.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 325,
    "name": "Medical Equipment & Services Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "18.62",
    "description": "This is a description for Medical Equipment & Services Product 5.",
    "rentPerDay": "9.68",
    "rentPerMonth": "112.78",
    "rentPerYear": "1972.55",
    "securityDeposit": "57.16",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 326,
    "name": "Medical Equipment & Services Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.30",
    "description": "This is a description for Medical Equipment & Services Product 6.",
    "rentPerDay": "9.41",
    "rentPerMonth": "293.56",
    "rentPerYear": "1568.55",
    "securityDeposit": "183.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 327,
    "name": "Medical Equipment & Services Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.99",
    "description": "This is a description for Medical Equipment & Services Product 7.",
    "rentPerDay": "0.20",
    "rentPerMonth": "297.60",
    "rentPerYear": "153.14",
    "securityDeposit": "233.84",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 328,
    "name": "Medical Equipment & Services Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "55.33",
    "description": "This is a description for Medical Equipment & Services Product 8.",
    "rentPerDay": "2.12",
    "rentPerMonth": "83.56",
    "rentPerYear": "3222.67",
    "securityDeposit": "195.26",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 329,
    "name": "Medical Equipment & Services Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.40",
    "description": "This is a description for Medical Equipment & Services Product 9.",
    "rentPerDay": "1.48",
    "rentPerMonth": "75.16",
    "rentPerYear": "1154.45",
    "securityDeposit": "263.17",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 330,
    "name": "Medical Equipment & Services Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.60",
    "description": "This is a description for Medical Equipment & Services Product 10.",
    "rentPerDay": "1.25",
    "rentPerMonth": "210.52",
    "rentPerYear": "1012.19",
    "securityDeposit": "51.66",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 331,
    "name": "Medical Equipment & Services Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "50.84",
    "description": "This is a description for Medical Equipment & Services Product 11.",
    "rentPerDay": "2.84",
    "rentPerMonth": "161.11",
    "rentPerYear": "430.15",
    "securityDeposit": "480.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 332,
    "name": "Medical Equipment & Services Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "97.37",
    "description": "This is a description for Medical Equipment & Services Product 12.",
    "rentPerDay": "8.20",
    "rentPerMonth": "231.02",
    "rentPerYear": "1511.13",
    "securityDeposit": "391.04",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 333,
    "name": "Medical Equipment & Services Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "34.49",
    "description": "This is a description for Medical Equipment & Services Product 13.",
    "rentPerDay": "9.14",
    "rentPerMonth": "77.25",
    "rentPerYear": "14.63",
    "securityDeposit": "90.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 334,
    "name": "Medical Equipment & Services Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.72",
    "description": "This is a description for Medical Equipment & Services Product 14.",
    "rentPerDay": "0.71",
    "rentPerMonth": "181.65",
    "rentPerYear": "1598.94",
    "securityDeposit": "74.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 335,
    "name": "Medical Equipment & Services Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.92",
    "description": "This is a description for Medical Equipment & Services Product 15.",
    "rentPerDay": "9.75",
    "rentPerMonth": "196.13",
    "rentPerYear": "1624.40",
    "securityDeposit": "247.77",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 336,
    "name": "Medical Equipment & Services Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.84",
    "description": "This is a description for Medical Equipment & Services Product 16.",
    "rentPerDay": "3.50",
    "rentPerMonth": "39.90",
    "rentPerYear": "356.06",
    "securityDeposit": "377.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 337,
    "name": "Medical Equipment & Services Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "97.09",
    "description": "This is a description for Medical Equipment & Services Product 17.",
    "rentPerDay": "9.39",
    "rentPerMonth": "43.41",
    "rentPerYear": "1521.13",
    "securityDeposit": "253.33",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 338,
    "name": "Medical Equipment & Services Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "64.01",
    "description": "This is a description for Medical Equipment & Services Product 18.",
    "rentPerDay": "0.48",
    "rentPerMonth": "181.51",
    "rentPerYear": "706.60",
    "securityDeposit": "349.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 339,
    "name": "Medical Equipment & Services Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.40",
    "description": "This is a description for Medical Equipment & Services Product 19.",
    "rentPerDay": "8.80",
    "rentPerMonth": "183.87",
    "rentPerYear": "2612.20",
    "securityDeposit": "44.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 340,
    "name": "Medical Equipment & Services Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "13.31",
    "description": "This is a description for Medical Equipment & Services Product 20.",
    "rentPerDay": "1.25",
    "rentPerMonth": "65.26",
    "rentPerYear": "2230.54",
    "securityDeposit": "391.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Medical Equipment & Services"
  },
  {
    "id": 341,
    "name": "Mobile Washrooms Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "9.22",
    "description": "This is a description for Mobile Washrooms Product 1.",
    "rentPerDay": "5.19",
    "rentPerMonth": "44.13",
    "rentPerYear": "1937.36",
    "securityDeposit": "148.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 342,
    "name": "Mobile Washrooms Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "22.23",
    "description": "This is a description for Mobile Washrooms Product 2.",
    "rentPerDay": "8.30",
    "rentPerMonth": "237.26",
    "rentPerYear": "3556.73",
    "securityDeposit": "247.64",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 343,
    "name": "Mobile Washrooms Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "51.31",
    "description": "This is a description for Mobile Washrooms Product 3.",
    "rentPerDay": "6.88",
    "rentPerMonth": "136.95",
    "rentPerYear": "1287.33",
    "securityDeposit": "33.66",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 344,
    "name": "Mobile Washrooms Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.07",
    "description": "This is a description for Mobile Washrooms Product 4.",
    "rentPerDay": "9.21",
    "rentPerMonth": "208.50",
    "rentPerYear": "1906.13",
    "securityDeposit": "272.98",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 345,
    "name": "Mobile Washrooms Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "0.58",
    "description": "This is a description for Mobile Washrooms Product 5.",
    "rentPerDay": "8.89",
    "rentPerMonth": "59.55",
    "rentPerYear": "219.96",
    "securityDeposit": "147.83",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 346,
    "name": "Mobile Washrooms Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "42.74",
    "description": "This is a description for Mobile Washrooms Product 6.",
    "rentPerDay": "9.56",
    "rentPerMonth": "142.59",
    "rentPerYear": "3142.97",
    "securityDeposit": "52.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 347,
    "name": "Mobile Washrooms Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "16.47",
    "description": "This is a description for Mobile Washrooms Product 7.",
    "rentPerDay": "7.96",
    "rentPerMonth": "87.60",
    "rentPerYear": "2691.24",
    "securityDeposit": "245.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 348,
    "name": "Mobile Washrooms Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.71",
    "description": "This is a description for Mobile Washrooms Product 8.",
    "rentPerDay": "8.34",
    "rentPerMonth": "149.93",
    "rentPerYear": "687.89",
    "securityDeposit": "259.30",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 349,
    "name": "Mobile Washrooms Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.03",
    "description": "This is a description for Mobile Washrooms Product 9.",
    "rentPerDay": "1.78",
    "rentPerMonth": "10.83",
    "rentPerYear": "3321.62",
    "securityDeposit": "365.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 350,
    "name": "Mobile Washrooms Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.44",
    "description": "This is a description for Mobile Washrooms Product 10.",
    "rentPerDay": "3.29",
    "rentPerMonth": "245.50",
    "rentPerYear": "2177.63",
    "securityDeposit": "28.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 351,
    "name": "Mobile Washrooms Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.52",
    "description": "This is a description for Mobile Washrooms Product 11.",
    "rentPerDay": "8.27",
    "rentPerMonth": "152.47",
    "rentPerYear": "1465.77",
    "securityDeposit": "153.50",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 352,
    "name": "Mobile Washrooms Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "38.61",
    "description": "This is a description for Mobile Washrooms Product 12.",
    "rentPerDay": "4.80",
    "rentPerMonth": "75.88",
    "rentPerYear": "1793.16",
    "securityDeposit": "409.49",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 353,
    "name": "Mobile Washrooms Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "16.80",
    "description": "This is a description for Mobile Washrooms Product 13.",
    "rentPerDay": "4.03",
    "rentPerMonth": "117.30",
    "rentPerYear": "1353.13",
    "securityDeposit": "234.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 354,
    "name": "Mobile Washrooms Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.88",
    "description": "This is a description for Mobile Washrooms Product 14.",
    "rentPerDay": "3.88",
    "rentPerMonth": "26.08",
    "rentPerYear": "2511.00",
    "securityDeposit": "170.16",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 355,
    "name": "Mobile Washrooms Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.81",
    "description": "This is a description for Mobile Washrooms Product 15.",
    "rentPerDay": "4.29",
    "rentPerMonth": "71.49",
    "rentPerYear": "2874.09",
    "securityDeposit": "339.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 356,
    "name": "Mobile Washrooms Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "71.39",
    "description": "This is a description for Mobile Washrooms Product 16.",
    "rentPerDay": "0.01",
    "rentPerMonth": "20.64",
    "rentPerYear": "232.03",
    "securityDeposit": "58.89",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 357,
    "name": "Mobile Washrooms Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.52",
    "description": "This is a description for Mobile Washrooms Product 17.",
    "rentPerDay": "4.37",
    "rentPerMonth": "265.56",
    "rentPerYear": "3211.39",
    "securityDeposit": "70.95",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 358,
    "name": "Mobile Washrooms Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "96.19",
    "description": "This is a description for Mobile Washrooms Product 18.",
    "rentPerDay": "7.50",
    "rentPerMonth": "180.45",
    "rentPerYear": "138.89",
    "securityDeposit": "65.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 359,
    "name": "Mobile Washrooms Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "66.85",
    "description": "This is a description for Mobile Washrooms Product 19.",
    "rentPerDay": "9.76",
    "rentPerMonth": "179.88",
    "rentPerYear": "1109.88",
    "securityDeposit": "74.72",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 360,
    "name": "Mobile Washrooms Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.09",
    "description": "This is a description for Mobile Washrooms Product 20.",
    "rentPerDay": "8.30",
    "rentPerMonth": "147.79",
    "rentPerYear": "2591.22",
    "securityDeposit": "496.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Mobile Washrooms"
  },
  {
    "id": 361,
    "name": "Musical Instruments Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.63",
    "description": "This is a description for Musical Instruments Product 1.",
    "rentPerDay": "8.33",
    "rentPerMonth": "94.17",
    "rentPerYear": "3097.39",
    "securityDeposit": "47.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 362,
    "name": "Musical Instruments Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "30.62",
    "description": "This is a description for Musical Instruments Product 2.",
    "rentPerDay": "8.41",
    "rentPerMonth": "12.85",
    "rentPerYear": "1612.70",
    "securityDeposit": "177.00",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 363,
    "name": "Musical Instruments Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.17",
    "description": "This is a description for Musical Instruments Product 3.",
    "rentPerDay": "7.41",
    "rentPerMonth": "18.99",
    "rentPerYear": "1684.13",
    "securityDeposit": "382.24",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 364,
    "name": "Musical Instruments Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.25",
    "description": "This is a description for Musical Instruments Product 4.",
    "rentPerDay": "3.82",
    "rentPerMonth": "245.81",
    "rentPerYear": "2132.30",
    "securityDeposit": "128.24",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 365,
    "name": "Musical Instruments Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.12",
    "description": "This is a description for Musical Instruments Product 5.",
    "rentPerDay": "8.82",
    "rentPerMonth": "17.03",
    "rentPerYear": "1457.89",
    "securityDeposit": "25.16",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 366,
    "name": "Musical Instruments Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.75",
    "description": "This is a description for Musical Instruments Product 6.",
    "rentPerDay": "1.52",
    "rentPerMonth": "124.35",
    "rentPerYear": "2314.30",
    "securityDeposit": "29.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 367,
    "name": "Musical Instruments Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.63",
    "description": "This is a description for Musical Instruments Product 7.",
    "rentPerDay": "4.01",
    "rentPerMonth": "79.24",
    "rentPerYear": "2777.88",
    "securityDeposit": "190.79",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 368,
    "name": "Musical Instruments Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.12",
    "description": "This is a description for Musical Instruments Product 8.",
    "rentPerDay": "5.77",
    "rentPerMonth": "11.08",
    "rentPerYear": "2309.94",
    "securityDeposit": "52.95",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 369,
    "name": "Musical Instruments Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.29",
    "description": "This is a description for Musical Instruments Product 9.",
    "rentPerDay": "5.39",
    "rentPerMonth": "34.49",
    "rentPerYear": "3038.25",
    "securityDeposit": "305.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 370,
    "name": "Musical Instruments Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.93",
    "description": "This is a description for Musical Instruments Product 10.",
    "rentPerDay": "2.03",
    "rentPerMonth": "231.04",
    "rentPerYear": "2331.65",
    "securityDeposit": "325.01",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 371,
    "name": "Musical Instruments Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "87.15",
    "description": "This is a description for Musical Instruments Product 11.",
    "rentPerDay": "3.55",
    "rentPerMonth": "261.74",
    "rentPerYear": "601.87",
    "securityDeposit": "2.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 372,
    "name": "Musical Instruments Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.83",
    "description": "This is a description for Musical Instruments Product 12.",
    "rentPerDay": "5.31",
    "rentPerMonth": "273.25",
    "rentPerYear": "2062.06",
    "securityDeposit": "455.07",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 373,
    "name": "Musical Instruments Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "20.60",
    "description": "This is a description for Musical Instruments Product 13.",
    "rentPerDay": "4.38",
    "rentPerMonth": "208.63",
    "rentPerYear": "1752.45",
    "securityDeposit": "171.34",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 374,
    "name": "Musical Instruments Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.34",
    "description": "This is a description for Musical Instruments Product 14.",
    "rentPerDay": "6.00",
    "rentPerMonth": "38.12",
    "rentPerYear": "2853.59",
    "securityDeposit": "274.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 375,
    "name": "Musical Instruments Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.33",
    "description": "This is a description for Musical Instruments Product 15.",
    "rentPerDay": "7.71",
    "rentPerMonth": "76.57",
    "rentPerYear": "2546.66",
    "securityDeposit": "89.92",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 376,
    "name": "Musical Instruments Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.18",
    "description": "This is a description for Musical Instruments Product 16.",
    "rentPerDay": "4.86",
    "rentPerMonth": "250.45",
    "rentPerYear": "3290.32",
    "securityDeposit": "285.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 377,
    "name": "Musical Instruments Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.52",
    "description": "This is a description for Musical Instruments Product 17.",
    "rentPerDay": "3.68",
    "rentPerMonth": "23.37",
    "rentPerYear": "1916.17",
    "securityDeposit": "430.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 378,
    "name": "Musical Instruments Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "87.09",
    "description": "This is a description for Musical Instruments Product 18.",
    "rentPerDay": "2.08",
    "rentPerMonth": "47.19",
    "rentPerYear": "1025.89",
    "securityDeposit": "40.96",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 379,
    "name": "Musical Instruments Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.87",
    "description": "This is a description for Musical Instruments Product 19.",
    "rentPerDay": "1.88",
    "rentPerMonth": "238.03",
    "rentPerYear": "275.50",
    "securityDeposit": "133.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 380,
    "name": "Musical Instruments Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.75",
    "description": "This is a description for Musical Instruments Product 20.",
    "rentPerDay": "1.16",
    "rentPerMonth": "230.10",
    "rentPerYear": "2754.66",
    "securityDeposit": "26.13",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Musical Instruments"
  },
  {
    "id": 381,
    "name": "Others Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.02",
    "description": "This is a description for Others Product 1.",
    "rentPerDay": "3.29",
    "rentPerMonth": "149.59",
    "rentPerYear": "3326.85",
    "securityDeposit": "441.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 382,
    "name": "Others Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "23.93",
    "description": "This is a description for Others Product 2.",
    "rentPerDay": "5.64",
    "rentPerMonth": "292.53",
    "rentPerYear": "1197.97",
    "securityDeposit": "198.82",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 383,
    "name": "Others Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "30.43",
    "description": "This is a description for Others Product 3.",
    "rentPerDay": "0.26",
    "rentPerMonth": "189.58",
    "rentPerYear": "1670.21",
    "securityDeposit": "370.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 384,
    "name": "Others Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "97.27",
    "description": "This is a description for Others Product 4.",
    "rentPerDay": "7.79",
    "rentPerMonth": "76.69",
    "rentPerYear": "526.00",
    "securityDeposit": "317.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 385,
    "name": "Others Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "34.53",
    "description": "This is a description for Others Product 5.",
    "rentPerDay": "1.64",
    "rentPerMonth": "177.47",
    "rentPerYear": "970.43",
    "securityDeposit": "377.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 386,
    "name": "Others Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.72",
    "description": "This is a description for Others Product 6.",
    "rentPerDay": "7.64",
    "rentPerMonth": "265.69",
    "rentPerYear": "3373.48",
    "securityDeposit": "405.47",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 387,
    "name": "Others Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.61",
    "description": "This is a description for Others Product 7.",
    "rentPerDay": "5.21",
    "rentPerMonth": "242.35",
    "rentPerYear": "1438.15",
    "securityDeposit": "419.54",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 388,
    "name": "Others Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.88",
    "description": "This is a description for Others Product 8.",
    "rentPerDay": "3.00",
    "rentPerMonth": "16.57",
    "rentPerYear": "687.59",
    "securityDeposit": "35.18",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 389,
    "name": "Others Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "28.14",
    "description": "This is a description for Others Product 9.",
    "rentPerDay": "1.32",
    "rentPerMonth": "88.51",
    "rentPerYear": "636.54",
    "securityDeposit": "417.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 390,
    "name": "Others Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "14.75",
    "description": "This is a description for Others Product 10.",
    "rentPerDay": "7.24",
    "rentPerMonth": "83.27",
    "rentPerYear": "1804.21",
    "securityDeposit": "248.08",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 391,
    "name": "Others Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.46",
    "description": "This is a description for Others Product 11.",
    "rentPerDay": "8.72",
    "rentPerMonth": "174.90",
    "rentPerYear": "1957.99",
    "securityDeposit": "34.85",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 392,
    "name": "Others Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.94",
    "description": "This is a description for Others Product 12.",
    "rentPerDay": "8.09",
    "rentPerMonth": "242.03",
    "rentPerYear": "2877.21",
    "securityDeposit": "93.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 393,
    "name": "Others Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.27",
    "description": "This is a description for Others Product 13.",
    "rentPerDay": "6.27",
    "rentPerMonth": "146.72",
    "rentPerYear": "3447.58",
    "securityDeposit": "12.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 394,
    "name": "Others Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.90",
    "description": "This is a description for Others Product 14.",
    "rentPerDay": "7.59",
    "rentPerMonth": "269.54",
    "rentPerYear": "645.09",
    "securityDeposit": "100.82",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 395,
    "name": "Others Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "65.06",
    "description": "This is a description for Others Product 15.",
    "rentPerDay": "6.32",
    "rentPerMonth": "249.91",
    "rentPerYear": "1589.32",
    "securityDeposit": "253.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 396,
    "name": "Others Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "41.51",
    "description": "This is a description for Others Product 16.",
    "rentPerDay": "5.00",
    "rentPerMonth": "165.99",
    "rentPerYear": "920.08",
    "securityDeposit": "450.63",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 397,
    "name": "Others Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "40.80",
    "description": "This is a description for Others Product 17.",
    "rentPerDay": "5.81",
    "rentPerMonth": "259.63",
    "rentPerYear": "1490.77",
    "securityDeposit": "209.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 398,
    "name": "Others Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.96",
    "description": "This is a description for Others Product 18.",
    "rentPerDay": "2.08",
    "rentPerMonth": "203.44",
    "rentPerYear": "1347.60",
    "securityDeposit": "59.79",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 399,
    "name": "Others Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "19.67",
    "description": "This is a description for Others Product 19.",
    "rentPerDay": "8.60",
    "rentPerMonth": "31.74",
    "rentPerYear": "3339.19",
    "securityDeposit": "62.25",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 400,
    "name": "Others Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "16.81",
    "description": "This is a description for Others Product 20.",
    "rentPerDay": "9.52",
    "rentPerMonth": "283.58",
    "rentPerYear": "1776.54",
    "securityDeposit": "62.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Others"
  },
  {
    "id": 401,
    "name": "Pets Care Services Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.52",
    "description": "This is a description for Pets Care Services Product 1.",
    "rentPerDay": "5.99",
    "rentPerMonth": "239.57",
    "rentPerYear": "2971.97",
    "securityDeposit": "329.03",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 402,
    "name": "Pets Care Services Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.76",
    "description": "This is a description for Pets Care Services Product 2.",
    "rentPerDay": "9.79",
    "rentPerMonth": "199.95",
    "rentPerYear": "2211.76",
    "securityDeposit": "31.89",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 403,
    "name": "Pets Care Services Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.79",
    "description": "This is a description for Pets Care Services Product 3.",
    "rentPerDay": "4.08",
    "rentPerMonth": "232.53",
    "rentPerYear": "2453.28",
    "securityDeposit": "205.83",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 404,
    "name": "Pets Care Services Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "70.45",
    "description": "This is a description for Pets Care Services Product 4.",
    "rentPerDay": "9.47",
    "rentPerMonth": "140.49",
    "rentPerYear": "685.08",
    "securityDeposit": "6.35",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 405,
    "name": "Pets Care Services Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "25.58",
    "description": "This is a description for Pets Care Services Product 5.",
    "rentPerDay": "4.31",
    "rentPerMonth": "275.27",
    "rentPerYear": "3184.06",
    "securityDeposit": "237.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 406,
    "name": "Pets Care Services Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.10",
    "description": "This is a description for Pets Care Services Product 6.",
    "rentPerDay": "4.80",
    "rentPerMonth": "292.16",
    "rentPerYear": "2179.02",
    "securityDeposit": "116.74",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 407,
    "name": "Pets Care Services Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "25.24",
    "description": "This is a description for Pets Care Services Product 7.",
    "rentPerDay": "3.63",
    "rentPerMonth": "155.50",
    "rentPerYear": "1355.11",
    "securityDeposit": "279.37",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 408,
    "name": "Pets Care Services Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "4.04",
    "description": "This is a description for Pets Care Services Product 8.",
    "rentPerDay": "6.36",
    "rentPerMonth": "59.28",
    "rentPerYear": "460.43",
    "securityDeposit": "48.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 409,
    "name": "Pets Care Services Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "46.77",
    "description": "This is a description for Pets Care Services Product 9.",
    "rentPerDay": "8.43",
    "rentPerMonth": "52.40",
    "rentPerYear": "1042.01",
    "securityDeposit": "298.64",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 410,
    "name": "Pets Care Services Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.55",
    "description": "This is a description for Pets Care Services Product 10.",
    "rentPerDay": "3.54",
    "rentPerMonth": "256.77",
    "rentPerYear": "3454.93",
    "securityDeposit": "368.19",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 411,
    "name": "Pets Care Services Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "42.01",
    "description": "This is a description for Pets Care Services Product 11.",
    "rentPerDay": "0.68",
    "rentPerMonth": "33.88",
    "rentPerYear": "177.46",
    "securityDeposit": "116.94",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 412,
    "name": "Pets Care Services Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.73",
    "description": "This is a description for Pets Care Services Product 12.",
    "rentPerDay": "3.30",
    "rentPerMonth": "251.58",
    "rentPerYear": "560.80",
    "securityDeposit": "352.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 413,
    "name": "Pets Care Services Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "80.55",
    "description": "This is a description for Pets Care Services Product 13.",
    "rentPerDay": "1.81",
    "rentPerMonth": "240.48",
    "rentPerYear": "1526.55",
    "securityDeposit": "0.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 414,
    "name": "Pets Care Services Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.99",
    "description": "This is a description for Pets Care Services Product 14.",
    "rentPerDay": "8.06",
    "rentPerMonth": "50.20",
    "rentPerYear": "1459.17",
    "securityDeposit": "397.24",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 415,
    "name": "Pets Care Services Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.89",
    "description": "This is a description for Pets Care Services Product 15.",
    "rentPerDay": "5.30",
    "rentPerMonth": "175.49",
    "rentPerYear": "281.10",
    "securityDeposit": "229.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 416,
    "name": "Pets Care Services Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.75",
    "description": "This is a description for Pets Care Services Product 16.",
    "rentPerDay": "1.90",
    "rentPerMonth": "265.87",
    "rentPerYear": "1524.12",
    "securityDeposit": "295.24",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 417,
    "name": "Pets Care Services Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.27",
    "description": "This is a description for Pets Care Services Product 17.",
    "rentPerDay": "2.38",
    "rentPerMonth": "225.00",
    "rentPerYear": "740.07",
    "securityDeposit": "446.00",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 418,
    "name": "Pets Care Services Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "96.89",
    "description": "This is a description for Pets Care Services Product 18.",
    "rentPerDay": "4.01",
    "rentPerMonth": "238.21",
    "rentPerYear": "1388.96",
    "securityDeposit": "195.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 419,
    "name": "Pets Care Services Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "1.01",
    "description": "This is a description for Pets Care Services Product 19.",
    "rentPerDay": "4.23",
    "rentPerMonth": "295.60",
    "rentPerYear": "499.17",
    "securityDeposit": "21.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 420,
    "name": "Pets Care Services Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "32.63",
    "description": "This is a description for Pets Care Services Product 20.",
    "rentPerDay": "5.79",
    "rentPerMonth": "81.58",
    "rentPerYear": "3341.77",
    "securityDeposit": "490.42",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Pets Care Services"
  },
  {
    "id": 421,
    "name": "Property Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "93.27",
    "description": "This is a description for Property Product 1.",
    "rentPerDay": "0.98",
    "rentPerMonth": "122.41",
    "rentPerYear": "1869.47",
    "securityDeposit": "482.10",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 422,
    "name": "Property Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "65.46",
    "description": "This is a description for Property Product 2.",
    "rentPerDay": "0.84",
    "rentPerMonth": "146.91",
    "rentPerYear": "2072.00",
    "securityDeposit": "43.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 423,
    "name": "Property Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.88",
    "description": "This is a description for Property Product 3.",
    "rentPerDay": "0.60",
    "rentPerMonth": "128.22",
    "rentPerYear": "157.89",
    "securityDeposit": "349.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 424,
    "name": "Property Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.84",
    "description": "This is a description for Property Product 4.",
    "rentPerDay": "1.40",
    "rentPerMonth": "245.14",
    "rentPerYear": "323.06",
    "securityDeposit": "9.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 425,
    "name": "Property Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "64.13",
    "description": "This is a description for Property Product 5.",
    "rentPerDay": "3.47",
    "rentPerMonth": "224.84",
    "rentPerYear": "1605.72",
    "securityDeposit": "448.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 426,
    "name": "Property Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "79.22",
    "description": "This is a description for Property Product 6.",
    "rentPerDay": "8.59",
    "rentPerMonth": "199.85",
    "rentPerYear": "1869.85",
    "securityDeposit": "137.96",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 427,
    "name": "Property Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.14",
    "description": "This is a description for Property Product 7.",
    "rentPerDay": "8.29",
    "rentPerMonth": "83.92",
    "rentPerYear": "2203.47",
    "securityDeposit": "353.77",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 428,
    "name": "Property Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.33",
    "description": "This is a description for Property Product 8.",
    "rentPerDay": "2.92",
    "rentPerMonth": "135.24",
    "rentPerYear": "3585.97",
    "securityDeposit": "234.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 429,
    "name": "Property Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.55",
    "description": "This is a description for Property Product 9.",
    "rentPerDay": "9.39",
    "rentPerMonth": "199.18",
    "rentPerYear": "371.08",
    "securityDeposit": "250.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 430,
    "name": "Property Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.33",
    "description": "This is a description for Property Product 10.",
    "rentPerDay": "6.42",
    "rentPerMonth": "183.32",
    "rentPerYear": "824.14",
    "securityDeposit": "26.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 431,
    "name": "Property Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "20.12",
    "description": "This is a description for Property Product 11.",
    "rentPerDay": "3.10",
    "rentPerMonth": "287.86",
    "rentPerYear": "523.30",
    "securityDeposit": "152.95",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 432,
    "name": "Property Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.88",
    "description": "This is a description for Property Product 12.",
    "rentPerDay": "7.59",
    "rentPerMonth": "177.44",
    "rentPerYear": "439.33",
    "securityDeposit": "323.81",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 433,
    "name": "Property Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "36.88",
    "description": "This is a description for Property Product 13.",
    "rentPerDay": "2.52",
    "rentPerMonth": "96.76",
    "rentPerYear": "1276.59",
    "securityDeposit": "191.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 434,
    "name": "Property Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "65.88",
    "description": "This is a description for Property Product 14.",
    "rentPerDay": "4.73",
    "rentPerMonth": "32.97",
    "rentPerYear": "1877.12",
    "securityDeposit": "455.41",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 435,
    "name": "Property Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.13",
    "description": "This is a description for Property Product 15.",
    "rentPerDay": "8.70",
    "rentPerMonth": "287.49",
    "rentPerYear": "1538.77",
    "securityDeposit": "460.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 436,
    "name": "Property Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.39",
    "description": "This is a description for Property Product 16.",
    "rentPerDay": "3.97",
    "rentPerMonth": "102.14",
    "rentPerYear": "733.98",
    "securityDeposit": "133.23",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 437,
    "name": "Property Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.49",
    "description": "This is a description for Property Product 17.",
    "rentPerDay": "8.41",
    "rentPerMonth": "293.58",
    "rentPerYear": "1555.06",
    "securityDeposit": "402.51",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 438,
    "name": "Property Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "78.10",
    "description": "This is a description for Property Product 18.",
    "rentPerDay": "8.33",
    "rentPerMonth": "218.79",
    "rentPerYear": "1331.18",
    "securityDeposit": "275.38",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 439,
    "name": "Property Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.63",
    "description": "This is a description for Property Product 19.",
    "rentPerDay": "6.68",
    "rentPerMonth": "223.83",
    "rentPerYear": "2434.64",
    "securityDeposit": "38.98",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 440,
    "name": "Property Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "71.42",
    "description": "This is a description for Property Product 20.",
    "rentPerDay": "6.87",
    "rentPerMonth": "71.74",
    "rentPerYear": "2644.02",
    "securityDeposit": "358.00",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Property"
  },
  {
    "id": 441,
    "name": "Security Equipment Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "98.15",
    "description": "This is a description for Security Equipment Product 1.",
    "rentPerDay": "2.45",
    "rentPerMonth": "167.20",
    "rentPerYear": "70.52",
    "securityDeposit": "435.87",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 442,
    "name": "Security Equipment Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.09",
    "description": "This is a description for Security Equipment Product 2.",
    "rentPerDay": "2.96",
    "rentPerMonth": "200.75",
    "rentPerYear": "781.47",
    "securityDeposit": "37.97",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 443,
    "name": "Security Equipment Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "57.93",
    "description": "This is a description for Security Equipment Product 3.",
    "rentPerDay": "9.77",
    "rentPerMonth": "65.83",
    "rentPerYear": "1857.26",
    "securityDeposit": "294.64",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 444,
    "name": "Security Equipment Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.40",
    "description": "This is a description for Security Equipment Product 4.",
    "rentPerDay": "9.88",
    "rentPerMonth": "275.52",
    "rentPerYear": "2310.41",
    "securityDeposit": "89.24",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 445,
    "name": "Security Equipment Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.55",
    "description": "This is a description for Security Equipment Product 5.",
    "rentPerDay": "5.19",
    "rentPerMonth": "94.05",
    "rentPerYear": "1411.21",
    "securityDeposit": "435.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 446,
    "name": "Security Equipment Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "79.19",
    "description": "This is a description for Security Equipment Product 6.",
    "rentPerDay": "3.54",
    "rentPerMonth": "26.06",
    "rentPerYear": "1025.23",
    "securityDeposit": "30.98",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 447,
    "name": "Security Equipment Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "45.23",
    "description": "This is a description for Security Equipment Product 7.",
    "rentPerDay": "6.95",
    "rentPerMonth": "25.72",
    "rentPerYear": "2964.42",
    "securityDeposit": "112.47",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 448,
    "name": "Security Equipment Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "85.62",
    "description": "This is a description for Security Equipment Product 8.",
    "rentPerDay": "0.94",
    "rentPerMonth": "174.29",
    "rentPerYear": "2559.76",
    "securityDeposit": "39.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 449,
    "name": "Security Equipment Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.67",
    "description": "This is a description for Security Equipment Product 9.",
    "rentPerDay": "6.00",
    "rentPerMonth": "187.05",
    "rentPerYear": "2959.67",
    "securityDeposit": "95.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 450,
    "name": "Security Equipment Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "49.28",
    "description": "This is a description for Security Equipment Product 10.",
    "rentPerDay": "0.17",
    "rentPerMonth": "274.12",
    "rentPerYear": "868.16",
    "securityDeposit": "352.62",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 451,
    "name": "Security Equipment Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "77.89",
    "description": "This is a description for Security Equipment Product 11.",
    "rentPerDay": "6.87",
    "rentPerMonth": "208.87",
    "rentPerYear": "940.74",
    "securityDeposit": "376.78",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 452,
    "name": "Security Equipment Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.01",
    "description": "This is a description for Security Equipment Product 12.",
    "rentPerDay": "3.31",
    "rentPerMonth": "205.31",
    "rentPerYear": "2154.19",
    "securityDeposit": "88.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 453,
    "name": "Security Equipment Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "17.35",
    "description": "This is a description for Security Equipment Product 13.",
    "rentPerDay": "1.85",
    "rentPerMonth": "237.43",
    "rentPerYear": "207.22",
    "securityDeposit": "219.76",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 454,
    "name": "Security Equipment Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.67",
    "description": "This is a description for Security Equipment Product 14.",
    "rentPerDay": "2.91",
    "rentPerMonth": "62.04",
    "rentPerYear": "119.09",
    "securityDeposit": "115.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 455,
    "name": "Security Equipment Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.90",
    "description": "This is a description for Security Equipment Product 15.",
    "rentPerDay": "9.79",
    "rentPerMonth": "28.88",
    "rentPerYear": "2479.74",
    "securityDeposit": "174.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 456,
    "name": "Security Equipment Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "74.89",
    "description": "This is a description for Security Equipment Product 16.",
    "rentPerDay": "7.86",
    "rentPerMonth": "243.01",
    "rentPerYear": "2621.24",
    "securityDeposit": "86.83",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 457,
    "name": "Security Equipment Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "1.72",
    "description": "This is a description for Security Equipment Product 17.",
    "rentPerDay": "4.88",
    "rentPerMonth": "281.43",
    "rentPerYear": "427.78",
    "securityDeposit": "430.51",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 458,
    "name": "Security Equipment Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "72.28",
    "description": "This is a description for Security Equipment Product 18.",
    "rentPerDay": "2.49",
    "rentPerMonth": "181.55",
    "rentPerYear": "2851.90",
    "securityDeposit": "195.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 459,
    "name": "Security Equipment Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "3.02",
    "description": "This is a description for Security Equipment Product 19.",
    "rentPerDay": "6.97",
    "rentPerMonth": "6.54",
    "rentPerYear": "42.97",
    "securityDeposit": "204.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 460,
    "name": "Security Equipment Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "67.09",
    "description": "This is a description for Security Equipment Product 20.",
    "rentPerDay": "2.24",
    "rentPerMonth": "176.36",
    "rentPerYear": "1939.13",
    "securityDeposit": "299.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Security Equipment"
  },
  {
    "id": 461,
    "name": "Services Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.72",
    "description": "This is a description for Services Product 1.",
    "rentPerDay": "2.06",
    "rentPerMonth": "120.41",
    "rentPerYear": "198.95",
    "securityDeposit": "485.60",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 462,
    "name": "Services Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "91.22",
    "description": "This is a description for Services Product 2.",
    "rentPerDay": "4.09",
    "rentPerMonth": "44.32",
    "rentPerYear": "1126.41",
    "securityDeposit": "409.33",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 463,
    "name": "Services Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.33",
    "description": "This is a description for Services Product 3.",
    "rentPerDay": "2.66",
    "rentPerMonth": "261.69",
    "rentPerYear": "1190.42",
    "securityDeposit": "370.33",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 464,
    "name": "Services Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "91.66",
    "description": "This is a description for Services Product 4.",
    "rentPerDay": "0.31",
    "rentPerMonth": "11.37",
    "rentPerYear": "3339.93",
    "securityDeposit": "439.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 465,
    "name": "Services Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.46",
    "description": "This is a description for Services Product 5.",
    "rentPerDay": "4.83",
    "rentPerMonth": "158.87",
    "rentPerYear": "3246.39",
    "securityDeposit": "88.14",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 466,
    "name": "Services Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.55",
    "description": "This is a description for Services Product 6.",
    "rentPerDay": "8.79",
    "rentPerMonth": "26.57",
    "rentPerYear": "206.97",
    "securityDeposit": "240.25",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 467,
    "name": "Services Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "82.52",
    "description": "This is a description for Services Product 7.",
    "rentPerDay": "4.55",
    "rentPerMonth": "98.93",
    "rentPerYear": "2235.85",
    "securityDeposit": "326.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 468,
    "name": "Services Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "76.47",
    "description": "This is a description for Services Product 8.",
    "rentPerDay": "8.77",
    "rentPerMonth": "204.50",
    "rentPerYear": "2269.69",
    "securityDeposit": "333.07",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 469,
    "name": "Services Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.75",
    "description": "This is a description for Services Product 9.",
    "rentPerDay": "6.11",
    "rentPerMonth": "173.38",
    "rentPerYear": "2324.84",
    "securityDeposit": "227.70",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 470,
    "name": "Services Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "2.59",
    "description": "This is a description for Services Product 10.",
    "rentPerDay": "8.07",
    "rentPerMonth": "217.87",
    "rentPerYear": "3535.84",
    "securityDeposit": "351.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 471,
    "name": "Services Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.40",
    "description": "This is a description for Services Product 11.",
    "rentPerDay": "1.58",
    "rentPerMonth": "85.54",
    "rentPerYear": "3430.05",
    "securityDeposit": "90.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 472,
    "name": "Services Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "41.50",
    "description": "This is a description for Services Product 12.",
    "rentPerDay": "5.21",
    "rentPerMonth": "225.78",
    "rentPerYear": "1199.75",
    "securityDeposit": "131.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 473,
    "name": "Services Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "96.69",
    "description": "This is a description for Services Product 13.",
    "rentPerDay": "1.79",
    "rentPerMonth": "263.93",
    "rentPerYear": "283.86",
    "securityDeposit": "176.45",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 474,
    "name": "Services Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "71.56",
    "description": "This is a description for Services Product 14.",
    "rentPerDay": "2.37",
    "rentPerMonth": "27.07",
    "rentPerYear": "119.83",
    "securityDeposit": "148.36",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 475,
    "name": "Services Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "26.42",
    "description": "This is a description for Services Product 15.",
    "rentPerDay": "6.23",
    "rentPerMonth": "59.02",
    "rentPerYear": "1121.10",
    "securityDeposit": "253.12",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 476,
    "name": "Services Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "89.59",
    "description": "This is a description for Services Product 16.",
    "rentPerDay": "5.65",
    "rentPerMonth": "225.31",
    "rentPerYear": "482.40",
    "securityDeposit": "122.28",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 477,
    "name": "Services Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "75.12",
    "description": "This is a description for Services Product 17.",
    "rentPerDay": "7.96",
    "rentPerMonth": "228.57",
    "rentPerYear": "1663.98",
    "securityDeposit": "165.22",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 478,
    "name": "Services Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.77",
    "description": "This is a description for Services Product 18.",
    "rentPerDay": "4.56",
    "rentPerMonth": "77.00",
    "rentPerYear": "3277.13",
    "securityDeposit": "360.15",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 479,
    "name": "Services Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "73.77",
    "description": "This is a description for Services Product 19.",
    "rentPerDay": "0.48",
    "rentPerMonth": "180.06",
    "rentPerYear": "3254.34",
    "securityDeposit": "481.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 480,
    "name": "Services Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "55.99",
    "description": "This is a description for Services Product 20.",
    "rentPerDay": "9.46",
    "rentPerMonth": "191.79",
    "rentPerYear": "3476.57",
    "securityDeposit": "406.46",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Services"
  },
  {
    "id": 481,
    "name": "Vending Machine Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.38",
    "description": "This is a description for Vending Machine Product 1.",
    "rentPerDay": "3.76",
    "rentPerMonth": "111.34",
    "rentPerYear": "531.75",
    "securityDeposit": "191.38",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 482,
    "name": "Vending Machine Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "38.31",
    "description": "This is a description for Vending Machine Product 2.",
    "rentPerDay": "0.61",
    "rentPerMonth": "184.59",
    "rentPerYear": "2062.17",
    "securityDeposit": "346.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 483,
    "name": "Vending Machine Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.72",
    "description": "This is a description for Vending Machine Product 3.",
    "rentPerDay": "6.47",
    "rentPerMonth": "109.45",
    "rentPerYear": "2816.41",
    "securityDeposit": "347.56",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 484,
    "name": "Vending Machine Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "54.43",
    "description": "This is a description for Vending Machine Product 4.",
    "rentPerDay": "7.78",
    "rentPerMonth": "12.96",
    "rentPerYear": "366.19",
    "securityDeposit": "332.68",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 485,
    "name": "Vending Machine Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "47.68",
    "description": "This is a description for Vending Machine Product 5.",
    "rentPerDay": "5.71",
    "rentPerMonth": "193.96",
    "rentPerYear": "2939.35",
    "securityDeposit": "134.93",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 486,
    "name": "Vending Machine Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "10.76",
    "description": "This is a description for Vending Machine Product 6.",
    "rentPerDay": "6.05",
    "rentPerMonth": "50.83",
    "rentPerYear": "2596.21",
    "securityDeposit": "235.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 487,
    "name": "Vending Machine Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.80",
    "description": "This is a description for Vending Machine Product 7.",
    "rentPerDay": "2.74",
    "rentPerMonth": "174.65",
    "rentPerYear": "3033.66",
    "securityDeposit": "440.05",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 488,
    "name": "Vending Machine Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "24.92",
    "description": "This is a description for Vending Machine Product 8.",
    "rentPerDay": "7.17",
    "rentPerMonth": "15.35",
    "rentPerYear": "1456.62",
    "securityDeposit": "21.69",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 489,
    "name": "Vending Machine Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "88.15",
    "description": "This is a description for Vending Machine Product 9.",
    "rentPerDay": "3.19",
    "rentPerMonth": "166.73",
    "rentPerYear": "2295.75",
    "securityDeposit": "258.99",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 490,
    "name": "Vending Machine Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "76.31",
    "description": "This is a description for Vending Machine Product 10.",
    "rentPerDay": "9.00",
    "rentPerMonth": "55.04",
    "rentPerYear": "615.06",
    "securityDeposit": "383.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 491,
    "name": "Vending Machine Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.25",
    "description": "This is a description for Vending Machine Product 11.",
    "rentPerDay": "1.13",
    "rentPerMonth": "260.67",
    "rentPerYear": "1182.16",
    "securityDeposit": "160.55",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 492,
    "name": "Vending Machine Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.04",
    "description": "This is a description for Vending Machine Product 12.",
    "rentPerDay": "1.79",
    "rentPerMonth": "66.10",
    "rentPerYear": "713.15",
    "securityDeposit": "11.57",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 493,
    "name": "Vending Machine Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "8.47",
    "description": "This is a description for Vending Machine Product 13.",
    "rentPerDay": "4.31",
    "rentPerMonth": "174.09",
    "rentPerYear": "2425.01",
    "securityDeposit": "67.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 494,
    "name": "Vending Machine Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "58.24",
    "description": "This is a description for Vending Machine Product 14.",
    "rentPerDay": "7.73",
    "rentPerMonth": "112.86",
    "rentPerYear": "1261.12",
    "securityDeposit": "479.33",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 495,
    "name": "Vending Machine Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "21.99",
    "description": "This is a description for Vending Machine Product 15.",
    "rentPerDay": "9.64",
    "rentPerMonth": "162.28",
    "rentPerYear": "3478.31",
    "securityDeposit": "386.44",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 496,
    "name": "Vending Machine Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "29.59",
    "description": "This is a description for Vending Machine Product 16.",
    "rentPerDay": "7.29",
    "rentPerMonth": "16.31",
    "rentPerYear": "2466.22",
    "securityDeposit": "197.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 497,
    "name": "Vending Machine Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "59.47",
    "description": "This is a description for Vending Machine Product 17.",
    "rentPerDay": "6.02",
    "rentPerMonth": "50.13",
    "rentPerYear": "3064.15",
    "securityDeposit": "219.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 498,
    "name": "Vending Machine Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "56.13",
    "description": "This is a description for Vending Machine Product 18.",
    "rentPerDay": "7.39",
    "rentPerMonth": "56.03",
    "rentPerYear": "550.17",
    "securityDeposit": "152.85",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 499,
    "name": "Vending Machine Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "32.36",
    "description": "This is a description for Vending Machine Product 19.",
    "rentPerDay": "3.64",
    "rentPerMonth": "143.44",
    "rentPerYear": "2415.51",
    "securityDeposit": "81.48",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 500,
    "name": "Vending Machine Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "7.46",
    "description": "This is a description for Vending Machine Product 20.",
    "rentPerDay": "5.63",
    "rentPerMonth": "281.47",
    "rentPerYear": "3452.22",
    "securityDeposit": "147.32",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Vending Machine"
  },
  {
    "id": 501,
    "name": "Wedding Couture Product 1",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "27.81",
    "description": "This is a description for Wedding Couture Product 1.",
    "rentPerDay": "0.94",
    "rentPerMonth": "15.71",
    "rentPerYear": "1696.32",
    "securityDeposit": "393.52",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 502,
    "name": "Wedding Couture Product 2",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.72",
    "description": "This is a description for Wedding Couture Product 2.",
    "rentPerDay": "2.08",
    "rentPerMonth": "113.63",
    "rentPerYear": "2998.68",
    "securityDeposit": "167.71",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 503,
    "name": "Wedding Couture Product 3",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.17",
    "description": "This is a description for Wedding Couture Product 3.",
    "rentPerDay": "5.04",
    "rentPerMonth": "217.52",
    "rentPerYear": "1728.83",
    "securityDeposit": "103.86",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 504,
    "name": "Wedding Couture Product 4",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "61.08",
    "description": "This is a description for Wedding Couture Product 4.",
    "rentPerDay": "2.22",
    "rentPerMonth": "86.84",
    "rentPerYear": "3333.60",
    "securityDeposit": "290.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 505,
    "name": "Wedding Couture Product 5",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "6.45",
    "description": "This is a description for Wedding Couture Product 5.",
    "rentPerDay": "8.09",
    "rentPerMonth": "216.25",
    "rentPerYear": "103.86",
    "securityDeposit": "32.25",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 506,
    "name": "Wedding Couture Product 6",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "69.82",
    "description": "This is a description for Wedding Couture Product 6.",
    "rentPerDay": "3.03",
    "rentPerMonth": "164.71",
    "rentPerYear": "3264.96",
    "securityDeposit": "303.91",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 507,
    "name": "Wedding Couture Product 7",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "76.94",
    "description": "This is a description for Wedding Couture Product 7.",
    "rentPerDay": "5.58",
    "rentPerMonth": "283.97",
    "rentPerYear": "2985.60",
    "securityDeposit": "322.04",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 508,
    "name": "Wedding Couture Product 8",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "94.73",
    "description": "This is a description for Wedding Couture Product 8.",
    "rentPerDay": "1.48",
    "rentPerMonth": "143.02",
    "rentPerYear": "1381.27",
    "securityDeposit": "355.39",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 509,
    "name": "Wedding Couture Product 9",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "31.60",
    "description": "This is a description for Wedding Couture Product 9.",
    "rentPerDay": "8.12",
    "rentPerMonth": "79.72",
    "rentPerYear": "1388.09",
    "securityDeposit": "469.11",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 510,
    "name": "Wedding Couture Product 10",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "91.37",
    "description": "This is a description for Wedding Couture Product 10.",
    "rentPerDay": "6.59",
    "rentPerMonth": "85.44",
    "rentPerYear": "1191.04",
    "securityDeposit": "58.21",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 511,
    "name": "Wedding Couture Product 11",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.88",
    "description": "This is a description for Wedding Couture Product 11.",
    "rentPerDay": "5.86",
    "rentPerMonth": "244.57",
    "rentPerYear": "1242.60",
    "securityDeposit": "464.20",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 512,
    "name": "Wedding Couture Product 12",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "68.89",
    "description": "This is a description for Wedding Couture Product 12.",
    "rentPerDay": "6.98",
    "rentPerMonth": "103.02",
    "rentPerYear": "732.03",
    "securityDeposit": "283.43",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 513,
    "name": "Wedding Couture Product 13",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "51.53",
    "description": "This is a description for Wedding Couture Product 13.",
    "rentPerDay": "6.99",
    "rentPerMonth": "108.61",
    "rentPerYear": "80.11",
    "securityDeposit": "352.72",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 514,
    "name": "Wedding Couture Product 14",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "39.85",
    "description": "This is a description for Wedding Couture Product 14.",
    "rentPerDay": "5.14",
    "rentPerMonth": "80.09",
    "rentPerYear": "1372.85",
    "securityDeposit": "261.58",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 515,
    "name": "Wedding Couture Product 15",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "11.65",
    "description": "This is a description for Wedding Couture Product 15.",
    "rentPerDay": "7.53",
    "rentPerMonth": "58.51",
    "rentPerYear": "759.37",
    "securityDeposit": "275.31",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 516,
    "name": "Wedding Couture Product 16",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "20.54",
    "description": "This is a description for Wedding Couture Product 16.",
    "rentPerDay": "8.96",
    "rentPerMonth": "135.33",
    "rentPerYear": "3117.92",
    "securityDeposit": "178.80",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 517,
    "name": "Wedding Couture Product 17",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "33.93",
    "description": "This is a description for Wedding Couture Product 17.",
    "rentPerDay": "9.30",
    "rentPerMonth": "148.22",
    "rentPerYear": "1788.22",
    "securityDeposit": "401.93",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 518,
    "name": "Wedding Couture Product 18",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "60.71",
    "description": "This is a description for Wedding Couture Product 18.",
    "rentPerDay": "6.77",
    "rentPerMonth": "167.56",
    "rentPerYear": "253.69",
    "securityDeposit": "327.88",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 519,
    "name": "Wedding Couture Product 19",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "86.38",
    "description": "This is a description for Wedding Couture Product 19.",
    "rentPerDay": "9.90",
    "rentPerMonth": "16.12",
    "rentPerYear": "49.19",
    "securityDeposit": "4.40",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  },
  {
    "id": 520,
    "name": "Wedding Couture Product 20",
    "image": "https://dummyimage.com/600x400/000/fff",
    "price": "5.18",
    "description": "This is a description for Wedding Couture Product 20.",
    "rentPerDay": "8.22",
    "rentPerMonth": "164.00",
    "rentPerYear": "2284.01",
    "securityDeposit": "493.53",
    "availabilityPlace": "Bengaluru, India",
    "categories": "Wedding Couture"
  }


];
export default product;